import { createTerraIcon } from '../../create-terra-icon';

const LabelImportantIconData = [
  ['path', { d: "M2.83827 5.49026C2.46331 4.82366 2.94502 4 3.70985 4H16.4458C16.7905 4 17.111 4.17762 17.2938 4.47L21.3375 10.94C21.7428 11.5885 21.7428 12.4115 21.3375 13.06L17.2938 19.53C17.111 19.8224 16.7905 20 16.4458 20H3.70985C2.94502 20 2.46331 19.1763 2.83827 18.5097L6.5 12L2.83827 5.49026Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const LabelImportantIcon = /* @__PURE__ */ createTerraIcon({
  icon: LabelImportantIconData,
  displayName: 'LabelImportantIcon',
});

const LabelIconData = [
  ['path', { d: "M2 6.00006C2 4.89549 2.89543 4.00006 4 4.00006H16.4458C16.7905 4.00006 17.111 4.17768 17.2938 4.47006L21.3375 10.9401C21.7428 11.5886 21.7428 12.4115 21.3375 13.0601L17.2938 19.5301C17.111 19.8224 16.7905 20.0001 16.4458 20.0001H4C2.89543 20.0001 2 19.1046 2 18.0001V6.00006Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const LabelIcon = /* @__PURE__ */ createTerraIcon({
  icon: LabelIconData,
  displayName: 'LabelIcon',
});

const LaborIconData = [
  ['path', { d: "M20 22V17C20 15.8954 19.1046 15 18 15H14L12 17L10 15H6C4.89543 15 4 15.8954 4 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16 15V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 15V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M15.5 9V7C15.5 5.067 13.933 3.5 12 3.5C10.067 3.5 8.5 5.067 8.5 7V9C8.5 10.933 10.067 12.5 12 12.5C13.933 12.5 15.5 10.933 15.5 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M7.5 7.5H16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M12 2V3.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
] as const;

export const LaborIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaborIconData,
  displayName: 'LaborIcon',
});

const LabsIconData = [
  ['path', { d: "M16.5 21C14.567 21 13 19.433 13 17.5L13 3L20 3L20 17.5C20 19.433 18.433 21 16.5 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 3L11 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15.5 7H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M20 11H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M6 11C6 11 10 13.5 10 16.75C10 19.0972 8.20914 21 6 21C3.79086 21 2 19.0972 2 16.75C2 13.5 6 11 6 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
] as const;

export const LabsIcon = /* @__PURE__ */ createTerraIcon({
  icon: LabsIconData,
  displayName: 'LabsIcon',
});

const LakeIconData = [
  ['path', { d: "M2 21.9684C2.94975 21.9684 3.88858 22.0553 4.67843 21.4396C5.45232 20.8365 6.68304 20.8564 7.42654 21.4842C8.2373 22.1688 9.76776 22.1494 10.5969 21.5032C11.4013 20.8763 12.6209 20.804 13.4265 21.4842C14.3106 22.2306 15.8003 22.1241 16.6784 21.4396C17.4523 20.8365 18.683 20.8564 19.4265 21.4842C20.1427 22.0889 21.1197 21.9684 22 21.9684", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 17.9684C2.94975 17.9684 3.88858 18.0553 4.67843 17.4396C5.45232 16.8365 6.68304 16.8564 7.42654 17.4842C8.2373 18.1688 9.76776 18.1494 10.5969 17.5032C11.4013 16.8763 12.6209 16.804 13.4265 17.4842C14.3106 18.2306 15.8003 18.1241 16.6784 17.4396C17.4523 16.8365 18.683 16.8564 19.4265 17.4842C20.1427 18.0889 21.1197 17.9684 22 17.9684", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2 14H22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6 14V6.64021M3 5.5C4 5.5 5 4 6 3C7 4 8 5.5 9 5.5M6 6C5.75 6.66667 4.5 8.5 3 8.5M6 6C6.25 6.66667 7.5 8.5 9 8.5M6 6V3.65819", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['circle', { cx: 17.5, cy: 4.5, r: 2.5, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LakeIcon = /* @__PURE__ */ createTerraIcon({
  icon: LakeIconData,
  displayName: 'LakeIcon',
});

const Lamp01IconData = [
  ['path', { d: "M9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.0002 20V22M15 19L17 20.4999M9 19L7 20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M5 13H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M18 13C18 9.68629 15.3137 7 12 7C8.68629 7 6 9.68629 6 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M12 7V2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const Lamp01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Lamp01IconData,
  displayName: 'Lamp01Icon',
});

const Lamp02IconData = [
  ['path', { d: "M9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.9816 20V22M14.9744 19L16.9697 20.4999M8.98847 19L6.99316 20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 6.5V2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M5.6641 9.50385L4 12C4 12 6.5 13 12 13C17.5 13 20 12 20 12L18.3359 9.50385C18.1169 9.17531 17.8055 8.91896 17.441 8.7671L12 6.5L6.55897 8.7671C6.19449 8.91896 5.88312 9.17531 5.6641 9.50385Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const Lamp02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Lamp02IconData,
  displayName: 'Lamp02Icon',
});

const Lamp03IconData = [
  ['path', { d: "M12.0005 10L12.0005 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.00049 22H16.0005", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.00049 22L9.77256 19.6838C9.90868 19.2754 10.2908 19 10.7212 19H13.2797C13.7102 19 14.0923 19.2754 14.2284 19.6838L15.0005 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M15.4673 10.0039V12.999", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M15.4832 3.18995L17.8776 8.59491C18.1705 9.25609 17.6864 9.99997 16.9632 9.99994L7.02602 9.99953C6.30565 9.9995 5.82162 9.2608 6.10921 8.60032L8.45989 3.20158C8.77761 2.47188 9.49773 2 10.2936 2H13.6546C14.4459 2 15.1628 2.46649 15.4832 3.18995Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
] as const;

export const Lamp03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Lamp03IconData,
  displayName: 'Lamp03Icon',
});

const Lamp04IconData = [
  ['path', { d: "M12 19C12.8284 19 13.5 18.3284 13.5 17.5C13.5 16.6716 12.8284 16 12 16C11.1716 16 10.5 16.6716 10.5 17.5C10.5 18.3284 11.1716 19 12 19Z", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M14.1459 2H9.85407C9.03626 2 8.30084 2.4979 7.99711 3.25722L5.04856 10.6286C4.78581 11.2855 5.26957 12 5.97703 12H18.023C18.7304 12 19.2142 11.2855 18.9514 10.6286L16.0029 3.25722C15.6992 2.4979 14.9637 2 14.1459 2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 12V16M12 19V22M12 22H8M12 22H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Lamp04Icon = /* @__PURE__ */ createTerraIcon({
  icon: Lamp04IconData,
  displayName: 'Lamp04Icon',
});

const Lamp05IconData = [
  ['path', { d: "M9.5 14C9.9431 14.924 10.1486 15.8586 9.65191 16.8944L8.69285 18.8944C8.13272 20.0625 8.91333 21.0415 9.49995 22H14.5C15.0866 21.0415 15.8652 20.0625 15.305 18.8944L14.346 16.8944C13.8492 15.8586 14.0569 14.924 14.5 14M8.5 14H15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 10.0039V14.0063", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 19L15 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M16.971 10H7.02902C6.30786 10 5.82381 9.25987 6.11286 8.59918L8.47572 3.19836C8.79421 2.47039 9.51344 2 10.308 2H13.692C14.4866 2 15.2058 2.47039 15.5243 3.19836L17.8871 8.59918C18.1762 9.25987 17.6921 10 16.971 10Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const Lamp05Icon = /* @__PURE__ */ createTerraIcon({
  icon: Lamp05IconData,
  displayName: 'Lamp05Icon',
});

const LampWallDownIconData = [
  ['path', { d: "M8.25774 21H19.7422C20.4368 21 21 20.4369 21 19.7422C21 19.5822 20.9694 19.4237 20.91 19.2751L18.3771 12.9429C18.1493 12.3734 17.5978 12 16.9844 12H11.0155C10.4022 12 9.8506 12.3734 9.6228 12.9429L7.08993 19.2751C7.0305 19.4237 6.99997 19.5822 6.99997 19.7422C6.99997 20.4369 7.56309 21 8.25774 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 16H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2.99997 8V4C2.99997 3.44772 3.44768 3 3.99997 3H4.99997C6.10454 3 6.99997 3.89543 6.99997 5V7C6.99997 8.10457 6.10454 9 4.99997 9H3.99997C3.44768 9 2.99997 8.55228 2.99997 8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M7 6H12C13.1046 6 14 6.89543 14 8V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LampWallDownIcon = /* @__PURE__ */ createTerraIcon({
  icon: LampWallDownIconData,
  displayName: 'LampWallDownIcon',
});

const LampWallUpIconData = [
  ['path', { d: "M8.25777 12H19.7422C20.4369 12 21 11.4369 21 10.7422C21 10.5822 20.9695 10.4237 20.91 10.2751L18.3772 3.94291C18.1494 3.37343 17.5978 3 16.9845 3H11.0155C10.4022 3 9.85063 3.37343 9.62283 3.94291L7.08996 10.2751C7.03053 10.4237 7 10.5822 7 10.7422C7 11.4369 7.56312 12 8.25777 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 7H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2.99997 16V20C2.99997 20.5523 3.44768 21 3.99997 21H4.99997C6.10454 21 6.99997 20.1046 6.99997 19V17C6.99997 15.8954 6.10454 15 4.99997 15H3.99997C3.44768 15 2.99997 15.4477 2.99997 16Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6.99994 18H11.9999C13.1045 18 13.9999 17.1046 13.9999 16V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LampWallUpIcon = /* @__PURE__ */ createTerraIcon({
  icon: LampWallUpIconData,
  displayName: 'LampWallUpIcon',
});

const LampIconData = [
  ['path', { d: "M12 13V19", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M9 22H15L14.4558 20.3675C14.1836 19.5509 13.4193 19 12.5585 19H11.4415C10.5807 19 9.81638 19.5509 9.54415 20.3675L9 22Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3.64264 11.5862L7.20064 3.75859C7.68745 2.68761 8.75531 2 9.93174 2H14.0683C15.2447 2 16.3125 2.68761 16.7994 3.75859L20.3574 11.5862C20.6583 12.2483 20.1743 13 19.447 13H4.553C3.82572 13 3.34168 12.2483 3.64264 11.5862Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const LampIcon = /* @__PURE__ */ createTerraIcon({
  icon: LampIconData,
  displayName: 'LampIcon',
});

const LandPlotIconData = [
  ['path', { d: "M15.0909 11.5L21.5673 15.2495C21.8351 15.4045 22 15.6905 22 16C22 16.3095 21.8351 16.5955 21.5673 16.7505L12.9327 21.7495C12.6492 21.9136 12.3275 22 12 22C11.6724 22 11.3507 21.9136 11.0673 21.7495L2.43268 16.7505C2.16487 16.5955 1.99997 16.3095 1.99997 16C1.99997 15.6905 2.16487 15.4045 2.43268 15.2495L8.90906 11.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17.25 12.75L6.75 19.25M6.75 12.75L17.25 19.25", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 8L18 5L12 2V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 12V8M12 8V2L18 5L12 8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LandPlotIcon = /* @__PURE__ */ createTerraIcon({
  icon: LandPlotIconData,
  displayName: 'LandPlotIcon',
});

const LandmarkIconData = [
  ['path', { d: "M3 21V20C3 19.4477 3.44772 19 4 19H20C20.5523 19 21 19.4477 21 20V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 7.57195C21 7.21758 20.8125 6.88968 20.507 6.71001L12.931 2.25351C12.6488 2.08753 12.3274 2 12 2C11.6726 2 11.3512 2.08753 11.069 2.25351L3.49298 6.71001C3.18754 6.88968 3 7.21758 3 7.57195V8H21V7.57195Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 11V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M14 11V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M10 11V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M6 11V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
] as const;

export const LandmarkIcon = /* @__PURE__ */ createTerraIcon({
  icon: LandmarkIconData,
  displayName: 'LandmarkIcon',
});

const LanguageCircleIconData = [
  ['circle', { cx: 12, cy: 12, r: 10, stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M7 8.5H11.5M11.5 8.5H17M11.5 8.5V7M8.5 17C11 15 14 11 14.5 8.5M10 11C10.5 12.5 12.5 15 13.5 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LanguageCircleIcon = /* @__PURE__ */ createTerraIcon({
  icon: LanguageCircleIconData,
  displayName: 'LanguageCircleIcon',
});

const LanguageSkillIconData = [
  ['path', { d: "M11 15H2.5122M2.5122 15C3.7477 18.4956 7.0814 21 11 21C9.3991 21 8.0911 17.238 8.0046 12.5M2.5122 15C2.2334 14.2113 2.0615 13.3722 2.0137 12.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.0156 8H21.5034M21.5034 8C20.2679 4.50442 16.9342 2 13.0156 2C14.6165 2 15.9245 5.76201 16.011 10.5M21.5034 8C21.7822 8.78867 21.9541 9.6278 22.0019 10.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M21 14H15C14.4477 14 14 14.4477 14 15V22L16.2625 20.6425C16.4179 20.5493 16.5957 20.5 16.777 20.5H21C21.5523 20.5 22 20.0523 22 19.5V15C22 14.4477 21.5523 14 21 14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M2 3C2 2.44772 2.44772 2 3 2H9C9.55228 2 10 2.44772 10 3V10L7.73751 8.64251C7.5821 8.54926 7.40426 8.5 7.22302 8.5H3C2.44772 8.5 2 8.05228 2 7.5V3Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LanguageSkillIcon = /* @__PURE__ */ createTerraIcon({
  icon: LanguageSkillIconData,
  displayName: 'LanguageSkillIcon',
});

const LanguageSquareIconData = [
  ['path', { d: "M7 8.5H11.5M11.5 8.5H17M11.5 8.5V7M8.5 17C11 15 14 11 14.5 8.5M10 11C10.5 12.5 12.5 15 13.5 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LanguageSquareIcon = /* @__PURE__ */ createTerraIcon({
  icon: LanguageSquareIconData,
  displayName: 'LanguageSquareIcon',
});

const LanternIconData = [
  ['rect', { x: 6, y: 7.5, width: 12, height: 11, stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6 7.5C6.71663 5.40983 8.72856 4 10.9947 4H13.0053C15.2714 4 17.2834 5.40983 18 7.5H6Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 18.5C17.2834 20.5902 15.2714 22 13.0053 22L10.9947 22C8.72855 22 6.71663 20.5902 6 18.5L18 18.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6.4 7.5H5L6.4 8.5M17.6 7.5H19L17.6 8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M17.6 18.5L19 18.5L17.6 17.5M6.4 18.5H5L6.4 17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M21 11L22 10.5M21 15L22 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M3 11L2 10.5M3 15L2 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
  ['path', { d: "M12 12V14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "7" }],
  ['path', { d: "M12 2V4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "8" }],
] as const;

export const LanternIcon = /* @__PURE__ */ createTerraIcon({
  icon: LanternIconData,
  displayName: 'LanternIcon',
});

const LaptopAddIconData = [
  ['path', { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.5 10H12M12 10L14.5 10M12 10L12 7.5M12 10V12.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopAddIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopAddIconData,
  displayName: 'LaptopAddIcon',
});

const LaptopChargingIconData = [
  ['path', { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 7L10.5 10H13.5L12 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopChargingIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopChargingIconData,
  displayName: 'LaptopChargingIcon',
});

const LaptopCheckIconData = [
  ['path', { d: "M22.4999 20.5H1.49988L3.49988 16.5H20.4999L22.4999 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.4999 16.5V5C20.4999 4.17157 19.8283 3.5 18.9999 3.5H4.99988C4.17145 3.5 3.49988 4.17157 3.49988 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.49995 10.3996L10.9999 11.9996L15.4999 7.99963", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopCheckIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopCheckIconData,
  displayName: 'LaptopCheckIcon',
});

const LaptopCloudIconData = [
  ['path', { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.5 12.5C8.67157 12.5 8 11.8284 8 11C8 10.1716 8.67157 9.5 9.5 9.5H10C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5H14.5C15.3284 9.5 16 10.1716 16 11C16 11.8284 15.3284 12.5 14.5 12.5H9.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopCloudIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopCloudIconData,
  displayName: 'LaptopCloudIcon',
});

const LaptopIssueIconData = [
  ['path', { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 13H12.009M12 10.5L12 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopIssueIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopIssueIconData,
  displayName: 'LaptopIssueIcon',
});

const LaptopPerformanceIconData = [
  ['path', { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M7.5 10H9.5L11 12.5L13 7.5L14.5 10H16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopPerformanceIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopPerformanceIconData,
  displayName: 'LaptopPerformanceIcon',
});

const LaptopPhoneSyncIconData = [
  ['path', { d: "M13 20.5H2L4 16.5H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 7.5V5C21 4.17157 20.3284 3.5 19.5 3.5H5.5C4.67157 3.5 4 4.17157 4 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M21 10.5H17C16.4477 10.5 16 10.9477 16 11.5V19.5C16 20.0523 16.4477 20.5 17 20.5H21C21.5523 20.5 22 20.0523 22 19.5V11.5C22 10.9477 21.5523 10.5 21 10.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopPhoneSyncIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopPhoneSyncIconData,
  displayName: 'LaptopPhoneSyncIcon',
});

const LaptopProgrammingIconData = [
  ['path', { d: "M20 14.5V3.5C20 2.94772 19.5523 2.5 19 2.5H5C4.44772 2.5 4 2.94772 4 3.5V14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.5 7L17 8.5L15.5 10M8.5 7L7 8.5L8.5 10M13 6L11 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3.32921 21.5C2.66379 21.5 2.18396 20.8622 2.36839 20.2229L4.01911 14.5H19.9514L21.6251 20.2191C21.8125 20.8593 21.3324 21.5 20.6654 21.5H3.32921Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopProgrammingIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopProgrammingIconData,
  displayName: 'LaptopProgrammingIcon',
});

const LaptopRemoveIconData = [
  ['path', { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10 8L12 10M12 10L14 12M12 10L14 8M12 10L10 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopRemoveIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopRemoveIconData,
  displayName: 'LaptopRemoveIcon',
});

const LaptopSettingsIconData = [
  ['path', { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 12L12 13.5M12 12C12.737 12 13.3809 11.6013 13.7278 11.0079M12 12C11.263 12 10.6191 11.6013 10.2722 11.0079M12 8L12 6.5M12 8C12.737 8 13.3809 8.39866 13.7278 8.99209M12 8C11.263 8 10.6191 8.39865 10.2722 8.99209M15 8.25L13.7278 8.99209M9 11.75L10.2722 11.0079M15 11.75L13.7278 11.0079M9 8.25L10.2722 8.99209M13.7278 11.0079C13.9009 10.7119 14 10.3676 14 10C14 9.63244 13.9009 9.28805 13.7278 8.99209M10.2722 8.99209C10.0992 9.28804 10 9.63244 10 10C10 10.3676 10.0991 10.712 10.2722 11.0079", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopSettingsIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopSettingsIconData,
  displayName: 'LaptopSettingsIcon',
});

const LaptopVideoIconData = [
  ['path', { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.5 10L10.5 7.5V12.5L14.5 10Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LaptopVideoIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopVideoIconData,
  displayName: 'LaptopVideoIcon',
});

const LaptopIconData = [
  ['path', { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LaptopIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaptopIconData,
  displayName: 'LaptopIcon',
});

const LassoSelectIconData = [
  ['path', { d: "M13.3375 12.0171L21.8411 15.2877C22.0582 15.3712 22.0511 15.6808 21.8305 15.7543L18.141 16.9842C18.0669 17.0088 18.0088 17.0669 17.9842 17.141L16.7543 20.8305C16.6808 21.0511 16.3712 21.0582 16.2877 20.8411L13.0171 12.3375C12.94 12.137 13.137 11.94 13.3375 12.0171Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5 17C3.89543 17 3 16.1046 3 15C3 13.8954 3.89543 13 5 13C6.10457 13 7 13.8954 7 15C7 16.1046 6.10457 17 5 17ZM5 17C5 18.6 6.33333 19.6667 7 20M21.8987 11C21.9655 10.6734 22 10.3395 22 10C22 6.13401 17.5228 3 12 3C6.47715 3 2 6.13401 2 10C2 11.3199 2.52185 12.5544 3.42901 13.6081M6.84631 16C8.08193 16.5212 9.49167 16.8606 11 16.9654", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LassoSelectIcon = /* @__PURE__ */ createTerraIcon({
  icon: LassoSelectIconData,
  displayName: 'LassoSelectIcon',
});

const LassoTool01IconData = [
  ['path', { d: "M17.3003 15.5116C20.3416 12.9804 22.6484 9.95901 21.8354 6.92985C20.7852 3.01732 15.5349 1.02232 10.1083 2.4739C4.68179 3.92547 1.13402 8.27394 2.18415 12.1865C3.03697 15.3638 5.88849 16.9746 10.3503 16.42M17.3003 15.5116C15.9161 11.5244 9.71766 12.8164 10.002 15.5116C10.2129 17.5105 14.9298 17.5105 17.3003 15.5116ZM17.3003 15.5116C18.1269 18.2959 16.2449 21.4457 12.9572 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const LassoTool01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LassoTool01IconData,
  displayName: 'LassoTool01Icon',
});

const LassoTool02IconData = [
  ['path', { d: "M9.98703 17C9.98703 18.1046 8.87064 19 7.49351 19C6.11638 19 5 18.1046 5 17C5 15.8954 6.11638 15 7.49351 15C8.87064 15 9.98703 15.8954 9.98703 17ZM9.98703 17C10.0493 17.7724 10.0064 20.5 7.00254 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5.5 15.5L2 2L13.5 6L22 2L21 15L10 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LassoTool02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LassoTool02IconData,
  displayName: 'LassoTool02Icon',
});

const LastFmIconData = [
  ['path', { d: "M21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.1429 14.5987C10.6386 14.8539 10.0531 15 9.42857 15C7.53502 15 6 13.6569 6 12C6 10.3431 7.53502 9 9.42857 9C11.5179 9.14167 12.1455 10.8522 12.5241 12C13.3813 14.5987 15.3389 15 16.2857 15C17.2325 15 18 14.3284 18 13.5C18 11.3216 14.5714 12.6784 14.5714 10.5C14.5714 9.67157 15.3389 9 16.2857 9C17.147 9 17.86 9.55579 17.9817 10.2799", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LastFmIcon = /* @__PURE__ */ createTerraIcon({
  icon: LastFmIconData,
  displayName: 'LastFmIcon',
});

const LatitudeIconData = [
  ['path', { d: "M3.5 7H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 12H22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3.5 17H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const LatitudeIcon = /* @__PURE__ */ createTerraIcon({
  icon: LatitudeIconData,
  displayName: 'LatitudeIcon',
});

const LaughingIconData = [
  ['path', { d: "M2 11C2.50421 5.94668 6.78892 2 12 2C17.2111 2 21.4958 5.94668 22 11M19 19.1752C17.1904 20.9235 14.7215 22 12 22C9.27848 22 6.80962 20.9235 5 19.1752", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 18C14.2091 18 16 16.2091 16 14H8C8 16.2091 9.79086 18 12 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5M14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6 12C4.44452 12.3985 1.54103 13.2338 2.06165 15.782C2.33013 17.0421 3.73652 17.275 4.5 16.708C6.33821 15.343 4.5 14 6 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M18 12C19.5555 12.3985 22.459 13.2338 21.9383 15.782C21.6699 17.0421 20.2635 17.275 19.5 16.708C17.6618 15.343 19.5 14 18 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LaughingIcon = /* @__PURE__ */ createTerraIcon({
  icon: LaughingIconData,
  displayName: 'LaughingIcon',
});

const LaurelWreath01IconData = [
  ['path', { d: "M6.43614 8C6.15488 8.84221 6 9.76282 6 10.7273C6 14.7439 8.68629 18 12 18C15.3137 18 18 14.7439 18 10.7273C18 9.76282 17.8451 8.84221 17.5639 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.5 21C14.5 21 13.818 18 12 18C10.182 18 9.5 21 9.5 21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18.5201 5.22967C18.812 6.89634 17.5003 8 17.5003 8C17.5003 8 15.8968 7.437 15.6049 5.77033C15.313 4.10366 16.6247 3 16.6247 3C16.6247 3 18.2282 3.56301 18.5201 5.22967Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M21.0942 12.1393C19.8128 13.4061 18.0778 12.9003 18.0778 12.9003C18.0778 12.9003 17.6241 11.1276 18.9055 9.86074C20.1868 8.59388 21.9219 9.09972 21.9219 9.09972C21.9219 9.09972 22.3756 10.8724 21.0942 12.1393Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M18.2335 18.1896C16.7335 17.614 16.5 16 16.5 16C16.5 16 17.7665 14.9616 19.2665 15.5372C20.7665 16.1128 21 17.7268 21 17.7268C21 17.7268 19.7335 18.7652 18.2335 18.1896Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M5.76651 18.1895C7.26651 17.6139 7.5 15.9999 7.5 15.9999C7.5 15.9999 6.23349 14.9615 4.73349 15.5371C3.23349 16.1127 3 17.7267 3 17.7267C3 17.7267 4.26651 18.7651 5.76651 18.1895Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M2.90565 12.1393C4.187 13.4061 5.92203 12.9003 5.92203 12.9003C5.92203 12.9003 6.37571 11.1276 5.09435 9.86074C3.813 8.59388 2.07797 9.09972 2.07797 9.09972C2.07797 9.09972 1.62429 10.8724 2.90565 12.1393Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
  ['path', { d: "M5.47987 5.22967C5.18799 6.89634 6.49968 8 6.49968 8C6.49968 8 8.10325 7.437 8.39513 5.77033C8.68701 4.10366 7.37532 3 7.37532 3C7.37532 3 5.77175 3.56301 5.47987 5.22967Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "7" }],
] as const;

export const LaurelWreath01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreath01IconData,
  displayName: 'LaurelWreath01Icon',
});

const LaurelWreath02IconData = [
  ['path', { d: "M18.3616 6.00046C18.8795 7.66713 17.7768 9 17.7768 9C17.7768 9 16.1562 8.66621 15.6384 6.99954C15.1205 5.33287 16.2232 4 16.2232 4C16.2232 4 17.8438 4.33379 18.3616 6.00046Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.9509 13.7774C19.6363 14.9862 18.028 14.3132 18.028 14.3132C18.028 14.3132 17.7344 12.4314 19.0491 11.2226C20.3637 10.0138 21.972 10.6868 21.972 10.6868C21.972 10.6868 22.2656 12.5686 20.9509 13.7774Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16.9261 19.7972C15.2594 19.1257 15 17.2427 15 17.2427C15 17.2427 16.4072 16.0313 18.0739 16.7028C19.7406 17.3743 20 19.2573 20 19.2573C20 19.2573 18.5928 20.4687 16.9261 19.7972Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M17.5644 9C17.8456 9.84221 18.0005 10.7628 18.0005 11.7273C18.0005 14.0564 16.4051 15.7992 15 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M5.63836 6.00046C5.12049 7.66713 6.22319 9 6.22319 9C6.22319 9 7.84377 8.66621 8.36164 6.99954C8.87951 5.33287 7.77681 4 7.77681 4C7.77681 4 6.15623 4.33379 5.63836 6.00046Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M3.04905 13.7774C4.36373 14.9862 5.97201 14.3132 5.97201 14.3132C5.97201 14.3132 6.26562 12.4314 4.95095 11.2226C3.63627 10.0138 2.02799 10.6868 2.02799 10.6868C2.02799 10.6868 1.73438 12.5686 3.04905 13.7774Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M7.0739 19.7972C8.74057 19.1257 9 17.2427 9 17.2427C9 17.2427 7.59277 16.0313 5.9261 16.7028C4.25944 17.3743 4 19.2573 4 19.2573C4 19.2573 5.40723 20.4687 7.0739 19.7972Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
  ['path', { d: "M6.43614 9C6.15488 9.84221 6 10.7628 6 11.7273C6 14.0564 7.59538 15.7992 9.00049 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "7" }],
] as const;

export const LaurelWreath02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreath02IconData,
  displayName: 'LaurelWreath02Icon',
});

const LaurelWreathFirst01IconData = [
  ['path', { d: "M6.43614 8C6.15488 8.84221 6 9.76282 6 10.7273C6 14.7439 8.68629 18 12 18C15.3137 18 18 14.7439 18 10.7273C18 9.76282 17.8451 8.84221 17.5639 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.5 21C14.5 21 13.818 18 12 18C10.182 18 9.5 21 9.5 21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18.5201 5.22967C18.812 6.89634 17.5003 8 17.5003 8C17.5003 8 15.8968 7.437 15.6049 5.77033C15.313 4.10366 16.6247 3 16.6247 3C16.6247 3 18.2282 3.56301 18.5201 5.22967Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M21.0942 12.1393C19.8128 13.4061 18.0778 12.9003 18.0778 12.9003C18.0778 12.9003 17.6241 11.1276 18.9055 9.86074C20.1868 8.59388 21.9219 9.09972 21.9219 9.09972C21.9219 9.09972 22.3756 10.8724 21.0942 12.1393Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M18.2335 18.1896C16.7335 17.614 16.5 16 16.5 16C16.5 16 17.7665 14.9616 19.2665 15.5372C20.7665 16.1128 21 17.7268 21 17.7268C21 17.7268 19.7335 18.7652 18.2335 18.1896Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M5.76651 18.1895C7.26651 17.6139 7.5 15.9999 7.5 15.9999C7.5 15.9999 6.23349 14.9615 4.73349 15.5371C3.23349 16.1127 3 17.7267 3 17.7267C3 17.7267 4.26651 18.7651 5.76651 18.1895Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M2.9054 12.1393C4.18676 13.4061 5.92179 12.9003 5.92179 12.9003C5.92179 12.9003 6.37546 11.1276 5.09411 9.86074C3.81276 8.59388 2.07773 9.09972 2.07773 9.09972C2.07773 9.09972 1.62405 10.8724 2.9054 12.1393Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
  ['path', { d: "M5.47987 5.22967C5.18799 6.89634 6.49968 8 6.49968 8C6.49968 8 8.10325 7.437 8.39513 5.77033C8.68701 4.10366 7.37532 3 7.37532 3C7.37532 3 5.77175 3.56301 5.47987 5.22967Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "7" }],
  ['path', { d: "M11 13.5H12M12 13.5H13M12 13.5V8.5L11 9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "8" }],
] as const;

export const LaurelWreathFirst01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreathFirst01IconData,
  displayName: 'LaurelWreathFirst01Icon',
});

const LaurelWreathFirst02IconData = [
  ['path', { d: "M18.3616 6.00046C18.8795 7.66713 17.7768 9 17.7768 9C17.7768 9 16.1562 8.66621 15.6384 6.99954C15.1205 5.33287 16.2232 4 16.2232 4C16.2232 4 17.8438 4.33379 18.3616 6.00046Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.9509 13.7774C19.6363 14.9862 18.028 14.3132 18.028 14.3132C18.028 14.3132 17.7344 12.4314 19.0491 11.2226C20.3637 10.0138 21.972 10.6868 21.972 10.6868C21.972 10.6868 22.2656 12.5686 20.9509 13.7774Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16.9261 19.7972C15.2594 19.1257 15 17.2427 15 17.2427C15 17.2427 16.4072 16.0313 18.0739 16.7028C19.7406 17.3743 20 19.2573 20 19.2573C20 19.2573 18.5928 20.4687 16.9261 19.7972Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M17.5644 9C17.8456 9.84221 18.0005 10.7628 18.0005 11.7273C18.0005 14.0564 16.4051 15.7992 15 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M5.63836 6.00046C5.12049 7.66713 6.22319 9 6.22319 9C6.22319 9 7.84377 8.66621 8.36164 6.99954C8.87951 5.33287 7.77681 4 7.77681 4C7.77681 4 6.15623 4.33379 5.63836 6.00046Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M3.04905 13.7774C4.36373 14.9862 5.97201 14.3132 5.97201 14.3132C5.97201 14.3132 6.26562 12.4314 4.95095 11.2226C3.63627 10.0138 2.02799 10.6868 2.02799 10.6868C2.02799 10.6868 1.73438 12.5686 3.04905 13.7774Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M7.0739 19.7972C8.74057 19.1257 9 17.2427 9 17.2427C9 17.2427 7.59277 16.0313 5.9261 16.7028C4.25944 17.3743 4 19.2573 4 19.2573C4 19.2573 5.40723 20.4687 7.0739 19.7972Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
  ['path', { d: "M6.43614 9C6.15488 9.84221 6 10.7628 6 11.7273C6 14.0564 7.59538 15.7992 9.00049 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "7" }],
  ['path', { d: "M11 14H12M12 14H13M12 14V9L11 9.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "8" }],
] as const;

export const LaurelWreathFirst02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreathFirst02IconData,
  displayName: 'LaurelWreathFirst02Icon',
});

const LaurelWreathLeft01IconData = [
  ['path', { d: "M12.3026 21.6574C13.9594 22.5085 16 21.5058 16 21.5058C16 21.5058 15.3543 19.1938 13.6974 18.3426C12.0406 17.4915 10 18.4942 10 18.4942C10 18.4942 10.6457 20.8062 12.3026 21.6574Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9.30257 17.6574C10.9594 18.5085 13 17.5058 13 17.5058C13 17.5058 12.3543 15.1938 10.6974 14.3426C9.04057 13.4915 7 14.4942 7 14.4942C7 14.4942 7.64572 16.8062 9.30257 17.6574Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M7.58178 12.3157C8.58089 13.851 10.8266 14 10.8266 14C10.8266 14 11.4173 11.7197 10.4182 10.1843C9.41911 8.64896 7.17343 8.5 7.17343 8.5C7.17343 8.5 6.58267 10.7803 7.58178 12.3157Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M8.50412 6.96086C8.60084 8.7652 10.5 10 10.5 10C10.5 10 12.0926 8.34347 11.9959 6.53913C11.8992 4.7348 10 3.5 10 3.5C10 3.5 8.4074 5.15653 8.50412 6.96086Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M12.7594 3.38931C11.6767 4.76486 12.0694 7 12.0694 7C12.0694 7 14.158 6.98625 15.2406 5.6107C16.3233 4.23514 15.9306 2 15.9306 2C15.9306 2 13.842 2.01375 12.7594 3.38931Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
] as const;

export const LaurelWreathLeft01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreathLeft01IconData,
  displayName: 'LaurelWreathLeft01Icon',
});

const LaurelWreathLeft02IconData = [
  ['path', { d: "M9.30257 17.6574C10.9594 18.5085 13 17.5058 13 17.5058C13 17.5058 12.3543 15.1938 10.6974 14.3426C9.04057 13.4915 7 14.4942 7 14.4942C7 14.4942 7.64572 16.8062 9.30257 17.6574Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7.58178 12.3157C8.58089 13.851 10.8266 14 10.8266 14C10.8266 14 11.4173 11.7197 10.4182 10.1843C9.41911 8.64896 7.17343 8.5 7.17343 8.5C7.17343 8.5 6.58267 10.7803 7.58178 12.3157Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8.50412 6.96086C8.60084 8.7652 10.5 10 10.5 10C10.5 10 12.0926 8.34347 11.9959 6.53913C11.8992 4.7348 10 3.5 10 3.5C10 3.5 8.4074 5.15653 8.50412 6.96086Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12.7594 3.38931C11.6767 4.76486 12.0694 7 12.0694 7C12.0694 7 14.158 6.98625 15.2406 5.6107C16.3233 4.23514 15.9306 2 15.9306 2C15.9306 2 13.842 2.01375 12.7594 3.38931Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M11 18H15C16.1046 18 17 18.8954 17 20C17 21.1046 16.1046 22 15 22H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LaurelWreathLeft02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreathLeft02IconData,
  displayName: 'LaurelWreathLeft02Icon',
});

const LaurelWreathLeft03IconData = [
  ['path', { d: "M10.9889 6.5C10.9889 6.5 12.821 6.4339 13.6618 4.9339C14.5025 3.4339 13.5111 2 13.5111 2C13.5111 2 11.6789 2.0661 10.8382 3.5661C9.9975 5.0661 10.9889 6.5 10.9889 6.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.1829 6.5C9.71953 8.59896 7.86589 13.475 12.1585 16.1875C17.5243 19.5781 18.0122 20.5469 18.5 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M16.0321 18.5C16.0321 18.5 12.4597 17.1364 14.5012 13.5C14.5012 13.5 18.5838 14.8636 16.0321 18.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M16 19.0001C16 19.0001 13.6326 15.9252 10.5 19.1051C10.5 19.1051 13.0077 22.6818 16 19.0001Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M9.49057 12.9391C9.49057 12.9391 9.88764 8.85377 5.52987 9.00405C5.52987 9.00405 4.89393 13.5764 9.49057 12.9391Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M9.50943 12.5001C9.50943 12.5001 9.11236 8.41482 13.4701 8.5651C13.4701 8.5651 14.1061 13.1374 9.50943 12.5001Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
] as const;

export const LaurelWreathLeft03Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreathLeft03IconData,
  displayName: 'LaurelWreathLeft03Icon',
});

const LaurelWreathRight01IconData = [
  ['path', { d: "M11.6974 21.6574C10.0406 22.5085 8 21.5058 8 21.5058C8 21.5058 8.64572 19.1938 10.3026 18.3426C11.9594 17.4915 14 18.4942 14 18.4942C14 18.4942 13.3543 20.8062 11.6974 21.6574Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.6974 17.6574C13.0406 18.5085 11 17.5058 11 17.5058C11 17.5058 11.6457 15.1938 13.3026 14.3426C14.9594 13.4915 17 14.4942 17 14.4942C17 14.4942 16.3543 16.8062 14.6974 17.6574Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16.4182 12.3157C15.4191 13.851 13.1734 14 13.1734 14C13.1734 14 12.5827 11.7197 13.5818 10.1843C14.5809 8.64896 16.8266 8.5 16.8266 8.5C16.8266 8.5 17.4173 10.7803 16.4182 12.3157Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M15.496 6.96086C15.3993 8.7652 13.5001 10 13.5001 10C13.5001 10 11.9075 8.34347 12.0042 6.53913C12.101 4.7348 14.0001 3.5 14.0001 3.5C14.0001 3.5 15.5927 5.15653 15.496 6.96086Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M11.2406 3.38931C12.3233 4.76486 11.9306 7 11.9306 7C11.9306 7 9.84204 6.98625 8.75937 5.6107C7.67669 4.23514 8.06943 2 8.06943 2C8.06943 2 10.158 2.01375 11.2406 3.38931Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
] as const;

export const LaurelWreathRight01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreathRight01IconData,
  displayName: 'LaurelWreathRight01Icon',
});

const LaurelWreathRight02IconData = [
  ['path', { d: "M14.6974 17.6574C13.0406 18.5085 11 17.5058 11 17.5058C11 17.5058 11.6457 15.1938 13.3026 14.3426C14.9594 13.4915 17 14.4942 17 14.4942C17 14.4942 16.3543 16.8062 14.6974 17.6574Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16.4182 12.3157C15.4191 13.851 13.1734 14 13.1734 14C13.1734 14 12.5827 11.7197 13.5818 10.1843C14.5809 8.64896 16.8266 8.5 16.8266 8.5C16.8266 8.5 17.4173 10.7803 16.4182 12.3157Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15.496 6.96086C15.3993 8.7652 13.5001 10 13.5001 10C13.5001 10 11.9075 8.34347 12.0042 6.53913C12.101 4.7348 14.0001 3.5 14.0001 3.5C14.0001 3.5 15.5927 5.15653 15.496 6.96086Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M11.2406 3.38931C12.3233 4.76486 11.9306 7 11.9306 7C11.9306 7 9.84204 6.98625 8.75937 5.6107C7.67669 4.23514 8.06943 2 8.06943 2C8.06943 2 10.158 2.01375 11.2406 3.38931Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M13 18H9C7.89543 18 7 18.8954 7 20C7 21.1046 7.89543 22 9 22H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LaurelWreathRight02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreathRight02IconData,
  displayName: 'LaurelWreathRight02Icon',
});

const LaurelWreathRight03IconData = [
  ['path', { d: "M13.0111 6.5C13.0111 6.5 11.179 6.4339 10.3382 4.9339C9.4975 3.4339 10.4889 2 10.4889 2C10.4889 2 12.321 2.0661 13.1618 3.5661C14.0025 5.0661 13.0111 6.5 13.0111 6.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.8171 6.5C14.2805 8.59896 16.1341 13.475 11.8415 16.1875C6.47567 19.5781 5.9878 20.5469 5.5 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M7.9679 18.5C7.9679 18.5 11.5403 17.1364 9.49877 13.5C9.49877 13.5 5.41625 14.8636 7.9679 18.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M8 19.0001C8 19.0001 10.3674 15.9252 13.5 19.105C13.5 19.105 10.9923 22.6818 8 19.0001Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M14.5094 12.9391C14.5094 12.9391 14.1124 8.85377 18.4701 9.00405C18.4701 9.00405 19.1061 13.5764 14.5094 12.9391Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M14.4906 12.5001C14.4906 12.5001 14.8876 8.41481 10.5299 8.56508C10.5299 8.56508 9.89393 13.1374 14.4906 12.5001Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
] as const;

export const LaurelWreathRight03Icon = /* @__PURE__ */ createTerraIcon({
  icon: LaurelWreathRight03IconData,
  displayName: 'LaurelWreathRight03Icon',
});

const LayerAddIconData = [
  ['path', { d: "M9 11C9 9.89543 9.89543 9 11 9H20C21.1046 9 22 9.89543 22 11V20C22 21.1046 21.1046 22 20 22H11C9.89543 22 9 21.1046 9 20V11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 15.5L13 15.5M15.5 13V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M17 9V4C17 2.89543 16.1046 2 15 2H4C2.89543 2 2 2.89543 2 4V15C2 16.1046 2.89543 17 4 17H8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const LayerAddIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayerAddIconData,
  displayName: 'LayerAddIcon',
});

const LayerBringForwardIconData = [
  ['path', { d: "M15.7442 11.5L21.3982 14.0485C22.2006 14.4102 22.2006 15.5898 21.3982 15.9515L12.7981 19.8279C12.289 20.0574 11.711 20.0574 11.2019 19.8279L2.60175 15.9515C1.79941 15.5898 1.79942 14.4102 2.60176 14.0485L8.25583 11.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 4.5V15M15 7L12 4L9 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LayerBringForwardIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayerBringForwardIconData,
  displayName: 'LayerBringForwardIcon',
});

const LayerBringToFrontIconData = [
  ['path', { d: "M12 2.5V10M15 5L12 2L9 5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16.8535 8L21.3982 10.0485C22.2006 10.4102 22.2006 11.5898 21.3982 11.9515L12.7981 15.8279C12.289 16.0574 11.711 16.0574 11.2019 15.8279L2.60175 11.9515C1.79941 11.5898 1.79942 10.4102 2.60176 10.0485L7.14654 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20.1813 15.5L21.3982 16.0485C22.2006 16.4102 22.2006 17.5898 21.3982 17.9515L12.7981 21.8279C12.289 22.0574 11.711 22.0574 11.2019 21.8279L2.60175 17.9515C1.79941 17.5898 1.79942 16.4102 2.60176 16.0485L3.81867 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LayerBringToFrontIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayerBringToFrontIconData,
  displayName: 'LayerBringToFrontIcon',
});

const LayerMask01IconData = [
  ['path', { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5 20L19 5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16 9L22 13.8528M12.4128 12.4059L19.3601 18.3634M8 15.6672L15 21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const LayerMask01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LayerMask01IconData,
  displayName: 'LayerMask01Icon',
});

const LayerMask02IconData = [
  ['path', { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M8.5 2.5C12.2967 3.93836 15 7.64912 15 12C15 16.3509 12.2967 20.0617 8.5 21.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
] as const;

export const LayerMask02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LayerMask02IconData,
  displayName: 'LayerMask02Icon',
});

const LayerSendBackwardIconData = [
  ['path', { d: "M15.7442 12.5L21.3982 9.95149C22.2006 9.58984 22.2006 8.41016 21.3982 8.04851L12.7981 4.17208C12.289 3.94264 11.711 3.94264 11.2019 4.17208L2.60175 8.04851C1.79941 8.41016 1.79942 9.58984 2.60176 9.95149L8.25583 12.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 19.5V9M15 17L12 20L9 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LayerSendBackwardIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayerSendBackwardIconData,
  displayName: 'LayerSendBackwardIcon',
});

const LayerSendToBackIconData = [
  ['path', { d: "M15.7442 10.5L21.3982 7.95149C22.2006 7.58984 22.2006 6.41016 21.3982 6.04851L12.7981 2.17208C12.289 1.94264 11.711 1.94264 11.2019 2.17208L2.60176 6.04851C1.79942 6.41016 1.79941 7.58984 2.60175 7.95149L8.25583 10.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 21.5V7M15 19L12 22L9 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20.1813 11.5L21.3982 12.0485C22.2006 12.4102 22.2006 13.5898 21.3982 13.9515L15.7442 16.5M3.81867 11.5L2.60176 12.0485C1.79942 12.4102 1.79941 13.5898 2.60175 13.9515L8.25583 16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LayerSendToBackIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayerSendToBackIconData,
  displayName: 'LayerSendToBackIcon',
});

const LayerIconData = [
  ['path', { d: "M11.2019 4.17208C11.711 3.94264 12.289 3.94264 12.7981 4.17208L21.3982 8.04851C22.2006 8.41016 22.2006 9.58984 21.3982 9.95149L12.7981 13.8279C12.289 14.0574 11.711 14.0574 11.2019 13.8279L2.60175 9.95149C1.79941 9.58984 1.79942 8.41016 2.60176 8.04851L11.2019 4.17208Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.1813 13.5L21.3982 14.0485C22.2006 14.4102 22.2006 15.5898 21.3982 15.9515L12.7981 19.8279C12.289 20.0574 11.711 20.0574 11.2019 19.8279L2.60175 15.9515C1.79941 15.5898 1.79942 14.4102 2.60176 14.0485L3.81867 13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LayerIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayerIconData,
  displayName: 'LayerIcon',
});

const Layers01IconData = [
  ['path', { d: "M11.5343 2.24513L4.18134 6.11508C3.46901 6.49 3.46901 7.51 4.18134 7.88492L11.5343 11.7549C11.8258 11.9083 12.1742 11.9083 12.4657 11.7549L19.8187 7.88492C20.531 7.51 20.531 6.49 19.8187 6.11508L12.4657 2.24513C12.1742 2.09169 11.8258 2.09169 11.5343 2.24513Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3.5 11L3.45978 11.0402C2.98334 11.5167 3.10489 12.3184 3.70116 12.6322L11.5343 16.7549C11.8258 16.9084 12.1742 16.9084 12.4657 16.7549L20.2988 12.6322C20.8951 12.3184 21.0167 11.5167 20.5402 11.0402L20.5 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3.5 16L3.45978 16.0402C2.98334 16.5167 3.10489 17.3184 3.70116 17.6322L11.5343 21.7549C11.8258 21.9084 12.1742 21.9084 12.4657 21.7549L20.2988 17.6322C20.8951 17.3184 21.0167 16.5167 20.5402 16.0402L20.5 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Layers01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Layers01IconData,
  displayName: 'Layers01Icon',
});

const Layers02IconData = [
  ['rect', { x: 11, y: 2, width: 11, height: 11, rx: 1, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10.5 6.5H7.5C6.94772 6.5 6.5 6.94771 6.5 7.5V16.5C6.5 17.0523 6.94771 17.5 7.5 17.5H16.5C17.0523 17.5 17.5 17.0523 17.5 16.5V13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6 11L3 11C2.44772 11 2 11.4477 2 12V21C2 21.5523 2.44771 22 3 22H12C12.5523 22 13 21.5523 13 21V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const Layers02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Layers02IconData,
  displayName: 'Layers02Icon',
});

const LayersLogoIconData = [
  ['path', { d: "M19.5 9.49988C20.6046 9.49988 21.5 10.3953 21.5 11.4999V19.4999C21.5 20.6044 20.6046 21.4999 19.5 21.4999H11.5C10.3954 21.4999 9.5 20.6044 9.5 19.4999V11.4999C9.5 10.3953 10.3954 9.49988 11.5 9.49988H19.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 9.5V7.99988C18 6.89531 17.1046 5.99988 16 5.99988H8C6.89543 5.99988 6 6.89531 6 7.99988V15.9999C6 17.1044 6.89543 17.9999 8 17.9999H9.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.5 6V4.49988C14.5 3.39531 13.6046 2.49988 12.5 2.49988H4.5C3.39543 2.49988 2.5 3.39531 2.5 4.49988V12.4999C2.5 13.6044 3.39543 14.4999 4.5 14.4999H6", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const LayersLogoIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayersLogoIconData,
  displayName: 'LayersLogoIcon',
});

const Layout01IconData = [
  ['path', { d: "M2.5 9H21.5", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M8 21.5V9", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const Layout01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Layout01IconData,
  displayName: 'Layout01Icon',
});

const Layout02IconData = [
  ['path', { d: "M2.5 9H21.5", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M16 21.5V9", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const Layout02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Layout02IconData,
  displayName: 'Layout02Icon',
});

const Layout03IconData = [
  ['path', { d: "M2.5 9H21.5", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M12 21.5V9", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const Layout03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Layout03IconData,
  displayName: 'Layout03Icon',
});

const Layout04IconData = [
  ['path', { d: "M9 2.5V21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 12.5H21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const Layout04Icon = /* @__PURE__ */ createTerraIcon({
  icon: Layout04IconData,
  displayName: 'Layout04Icon',
});

const Layout05IconData = [
  ['path', { d: "M2.5 9H21.5", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16 21.5V9", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
  ['path', { d: "M8 21.5V9", stroke: "currentColor", strokeWidth: 1.5, key: "3" }],
] as const;

export const Layout05Icon = /* @__PURE__ */ createTerraIcon({
  icon: Layout05IconData,
  displayName: 'Layout05Icon',
});

const Layout06IconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 21.5V2.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M21.5 8H9", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
  ['path', { d: "M21.5 16H9", stroke: "currentColor", strokeWidth: 1.5, key: "3" }],
] as const;

export const Layout06Icon = /* @__PURE__ */ createTerraIcon({
  icon: Layout06IconData,
  displayName: 'Layout06Icon',
});

const Layout07IconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2.5 9H21.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M8 15H21.5", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
  ['path', { d: "M8 21.5V9", stroke: "currentColor", strokeWidth: 1.5, key: "3" }],
] as const;

export const Layout07Icon = /* @__PURE__ */ createTerraIcon({
  icon: Layout07IconData,
  displayName: 'Layout07Icon',
});

const Layout2ColumnIconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2.5V21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const Layout2ColumnIcon = /* @__PURE__ */ createTerraIcon({
  icon: Layout2ColumnIconData,
  displayName: 'Layout2ColumnIcon',
});

const Layout2RowIconData = [
  ['path', { d: "M2.5 12H21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const Layout2RowIcon = /* @__PURE__ */ createTerraIcon({
  icon: Layout2RowIconData,
  displayName: 'Layout2RowIcon',
});

const Layout3ColumnIconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.5 2.5V21.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M15.5 2.5V21.5", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
] as const;

export const Layout3ColumnIcon = /* @__PURE__ */ createTerraIcon({
  icon: Layout3ColumnIconData,
  displayName: 'Layout3ColumnIcon',
});

const Layout3RowIconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21.5 8.5H2.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M21.5 15.5H2.5", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
] as const;

export const Layout3RowIcon = /* @__PURE__ */ createTerraIcon({
  icon: Layout3RowIconData,
  displayName: 'Layout3RowIcon',
});

const LayoutAlignBottomIconData = [
  ['path', { d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16 16H8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LayoutAlignBottomIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutAlignBottomIconData,
  displayName: 'LayoutAlignBottomIcon',
});

const LayoutAlignLeftIconData = [
  ['path', { d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.00488 16.0049L8.00488 8.00488", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LayoutAlignLeftIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutAlignLeftIconData,
  displayName: 'LayoutAlignLeftIcon',
});

const LayoutAlignRightIconData = [
  ['path', { d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.9951 8.00488L15.9951 16.0049", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LayoutAlignRightIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutAlignRightIconData,
  displayName: 'LayoutAlignRightIcon',
});

const LayoutAlignTopIconData = [
  ['path', { d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16 8H8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LayoutAlignTopIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutAlignTopIconData,
  displayName: 'LayoutAlignTopIcon',
});

const LayoutBottomIconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2.5 15H21.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
] as const;

export const LayoutBottomIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutBottomIconData,
  displayName: 'LayoutBottomIcon',
});

const LayoutGridIconData = [
  ['path', { d: "M21.5 12L2.5 12M12 2.5V21.5", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LayoutGridIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutGridIconData,
  displayName: 'LayoutGridIcon',
});

const LayoutLeftIconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 21.5V2.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
] as const;

export const LayoutLeftIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutLeftIconData,
  displayName: 'LayoutLeftIcon',
});

const LayoutRightIconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 21.5V2.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
] as const;

export const LayoutRightIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutRightIconData,
  displayName: 'LayoutRightIcon',
});

const LayoutTable01IconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2.5 9H21.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M16 21.5V2.5", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
  ['path', { d: "M8 21.5V2.5", stroke: "currentColor", strokeWidth: 1.5, key: "3" }],
] as const;

export const LayoutTable01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutTable01IconData,
  displayName: 'LayoutTable01Icon',
});

const LayoutTable02IconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 21.5V2.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M21.4999 8H2.5", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
  ['path', { d: "M21.4999 16H2.5", stroke: "currentColor", strokeWidth: 1.5, key: "3" }],
] as const;

export const LayoutTable02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutTable02IconData,
  displayName: 'LayoutTable02Icon',
});

const LayoutTopIconData = [
  ['path', { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2.5 9H21.5", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
] as const;

export const LayoutTopIcon = /* @__PURE__ */ createTerraIcon({
  icon: LayoutTopIconData,
  displayName: 'LayoutTopIcon',
});

const Leaf01IconData = [
  ['path', { d: "M7.64584 15.7108C7.23279 14.8966 7 13.9755 7 13C7 9.78484 9.5 7.5 13 7C17.0817 6.4169 18.8333 4.16667 20 3C23.5 16 17 19 13 19C11.9071 19 10.8825 18.7078 10 18.1973", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 21C3.5 18 5.45791 16.1355 10 15C13.2167 14.1958 15.4634 12.1242 17 10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const Leaf01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Leaf01IconData,
  displayName: 'Leaf01Icon',
});

const Leaf02IconData = [
  ['path', { d: "M3 21L17 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M6.69577 17.3042C4.5632 15.1717 3.85234 11.6174 8.11749 7.3522C13.4489 2.02076 20.913 3.08704 20.913 3.08704C20.913 3.08704 21.9792 10.5511 16.6478 15.8825C14.1373 18.3931 11.873 19.1796 10 18.9669", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Leaf02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Leaf02IconData,
  displayName: 'Leaf02Icon',
});

const Leaf03IconData = [
  ['path', { d: "M6.67504 17.325C3.77499 14.4249 3.77499 9.72297 6.67504 6.82291C10.6133 2.88465 20.459 3.54102 20.459 3.54102C20.459 3.54102 21.1154 13.3867 17.1771 17.325C15.2327 19.2694 12.4783 19.9101 10 19.2472", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3.5 20.5L15.5 8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const Leaf03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Leaf03IconData,
  displayName: 'Leaf03Icon',
});

const Leaf04IconData = [
  ['path', { d: "M8.15658 15.8434C7.07994 15.8362 5.59735 15.5728 4.43407 14.4096C2.3623 12.3378 3.14497 9.25318 3.14497 9.25318C3.14497 9.25318 4.76016 8.84345 6.43811 9.40194C6.10717 6.92074 7.48292 4.3172 9.59044 3C9.59044 3 11.5931 4.25174 12.4323 6.55719C15.2245 4.60372 19 5 19 5C19 5 19.4535 8.7078 17.5 11.5C19.8054 12.3392 21 14.5 21 14.5C19.6832 16.6068 16.9808 17.8321 14.5 17.5C15.0585 19.178 14.7468 20.855 14.7468 20.855C14.7468 20.855 11.6622 21.6377 9.59044 19.5659", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 21L13 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const Leaf04Icon = /* @__PURE__ */ createTerraIcon({
  icon: Leaf04IconData,
  displayName: 'Leaf04Icon',
});

const LeafyGreenIconData = [
  ['path', { d: "M3.94906 20.051L3 21M3.94906 20.051C5.52151 18.4785 8.07096 18.4785 9.64341 20.051C10.8664 21.274 12.8493 21.274 14.0723 20.051C14.6519 19.4714 14.9559 18.7211 14.9862 17.962C16.0741 18.3212 17.3195 18.0692 18.1849 17.2038C19.1704 16.2184 19.3615 14.7398 18.7589 13.5627C19.2436 13.4195 19.7006 13.1574 20.083 12.775C21.3061 11.552 21.3054 9.56849 20.0824 8.34549C21.2833 7.12081 21.2764 5.15506 20.0608 3.93949C18.8452 2.72392 16.8788 2.71643 15.6541 3.91725C14.4311 2.69425 12.4482 2.69425 11.2252 3.91725C10.8428 4.29961 10.58 4.75625 10.4368 5.24072C9.25978 4.63862 7.78146 4.83012 6.79623 5.81533C5.93105 6.6805 5.67858 7.92572 6.03748 9.0134C5.27852 9.04379 4.5285 9.34841 3.94906 9.92785C2.72604 11.1508 2.72604 13.1337 3.94906 14.3567C5.52151 15.9291 5.52151 18.4785 3.94906 20.051Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5 19L15 9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LeafyGreenIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeafyGreenIconData,
  displayName: 'LeafyGreenIcon',
});

const LeavingGeoFenceIconData = [
  ['path', { d: "M12 16.5001L12 3.84494M15.5 6.50006L12 3L8.5 6.50006", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5 15C3.7492 15.6327 3 16.4385 3 17.3158C3 19.3505 7.02944 21 12 21C16.9706 21 21 19.3505 21 17.3158C21 16.4385 20.2508 15.6327 19 15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LeavingGeoFenceIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeavingGeoFenceIconData,
  displayName: 'LeavingGeoFenceIcon',
});

const LeetcodeIconData = [
  ['path', { d: "M14 3L4 13L12 21L16 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 3L12 5M4 13L12 5M12 5L16 9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 13H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M12 5L16 9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LeetcodeIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeetcodeIconData,
  displayName: 'LeetcodeIcon',
});

const LeftAngleIconData = [
  ['path', { d: "M18 12H14C12.8954 12 12 12.8954 12 14V18", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M3 18.5H17.5C18.0523 18.5 18.5 18.0523 18.5 17.5V3M3 18.5L5.5 16M3 18.5L5.5 21M18.5 3L16 5.5M18.5 3L21 5.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LeftAngleIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeftAngleIconData,
  displayName: 'LeftAngleIcon',
});

const LeftToRightBlockQuoteIconData = [
  ['path', { d: "M9 6H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M9 12H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M9 18H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M5 3V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LeftToRightBlockQuoteIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeftToRightBlockQuoteIconData,
  displayName: 'LeftToRightBlockQuoteIcon',
});

const LeftToRightListBulletIconData = [
  ['path', { d: "M8 5L20 5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M8 12L20 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M8 19L20 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M4.375 5H4.25M4.5 5C4.5 5.13807 4.38807 5.25 4.25 5.25C4.11193 5.25 4 5.13807 4 5C4 4.86193 4.11193 4.75 4.25 4.75C4.38807 4.75 4.5 4.86193 4.5 5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M4.375 12H4.25M4.5 12C4.5 12.1381 4.38807 12.25 4.25 12.25C4.11193 12.25 4 12.1381 4 12C4 11.8619 4.11193 11.75 4.25 11.75C4.38807 11.75 4.5 11.8619 4.5 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M4.375 19H4.25M4.5 19C4.5 19.1381 4.38807 19.25 4.25 19.25C4.11193 19.25 4 19.1381 4 19C4 18.8619 4.11193 18.75 4.25 18.75C4.38807 18.75 4.5 18.8619 4.5 19Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
] as const;

export const LeftToRightListBulletIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeftToRightListBulletIconData,
  displayName: 'LeftToRightListBulletIcon',
});

const LeftToRightListDashIconData = [
  ['path', { d: "M9 5H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M3 5H5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M9 12H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M3 12H5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "3" }],
  ['path', { d: "M9 19H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "4" }],
  ['path', { d: "M3 19H5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "5" }],
] as const;

export const LeftToRightListDashIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeftToRightListDashIconData,
  displayName: 'LeftToRightListDashIcon',
});

const LeftToRightListNumberIconData = [
  ['path', { d: "M3 15H6V18H3.00034V21H6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 3H4.5V9M4.5 9H3M4.5 9H6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 6L21 6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M11 12L21 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "3" }],
  ['path', { d: "M11 18L21 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "4" }],
] as const;

export const LeftToRightListNumberIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeftToRightListNumberIconData,
  displayName: 'LeftToRightListNumberIcon',
});

const LeftToRightListStar01IconData = [
  ['path', { d: "M3 5.5L12.5 5.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M3 12L12.5 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M3 18.5L12.5 18.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M21 18.5L16 18.5M17 21L20 16M20 21L17 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M21 5.5L16 5.5M17 8L20 3M20 8L17 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LeftToRightListStar01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LeftToRightListStar01IconData,
  displayName: 'LeftToRightListStar01Icon',
});

const LeftToRightListStarIconData = [
  ['path', { d: "M11.5 5.5L21 5.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M11.5 12L21 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M11.5 18.5L21 18.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M8 18.5L3 18.5M4 21L7 16M7 21L4 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M8 5.5L3 5.5M4 8L7 3M7 8L4 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LeftToRightListStarIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeftToRightListStarIconData,
  displayName: 'LeftToRightListStarIcon',
});

const LeftToRightListTriangleIconData = [
  ['path', { d: "M7 5.5L3 3V8L7 5.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 18.5L3 16V21L7 18.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 5.5L21 5.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M11 12L21 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "3" }],
  ['path', { d: "M11 18.5L21 18.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "4" }],
] as const;

export const LeftToRightListTriangleIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeftToRightListTriangleIconData,
  displayName: 'LeftToRightListTriangleIcon',
});

const LeftTriangleIconData = [
  ['path', { d: "M19.2932 14.293H16.2932C15.1886 14.293 14.2932 15.1884 14.2932 16.293V19.293", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21.2932 10.2882L20.2999 10.2884C19.7477 10.2885 19.3001 10.7362 19.3001 11.2884V18.2881C19.3001 18.8404 18.8524 19.2881 18.3001 19.2881H11.2977C10.7454 19.2881 10.2977 19.7359 10.2977 20.2881V21.293M19.2932 6.78882L19.2971 3.71031C19.2982 2.81897 18.2207 2.37164 17.5902 3.00168L3.00197 17.5793C2.37162 18.2092 2.81777 19.2868 3.70889 19.2867L6.79319 19.2865", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LeftTriangleIcon = /* @__PURE__ */ createTerraIcon({
  icon: LeftTriangleIconData,
  displayName: 'LeftTriangleIcon',
});

const Legal01IconData = [
  ['path', { d: "M12.5 22L13.8618 19.2764C13.9465 19.107 14.1196 19 14.309 19H17.691C17.8804 19 18.0535 19.107 18.1382 19.2764L19.5 22M11.5 22H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 12L22 10M20 15L22 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.5 2.00098L8.79544 2.55701M8.79544 2.55701C10.1674 3.6248 13.0895 6.21128 13.3076 6.47091C13.5667 6.68966 15.8546 9.32441 16.919 10.699M8.79544 2.55701L5.05277 6.29062M5.05277 6.29062L4.5 7.00098M5.05277 6.29062C5.62998 6.99619 6.50031 8.05884 7.27257 8.96617C8.25861 10.1247 9.3449 11.2135 10.5011 12.2022C11.4083 12.9781 12.4714 13.8529 13.176 14.4324M17.5 10.001L16.919 10.699M16.919 10.699L13.176 14.4324M13.176 14.4324L12.5 15.001", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M10 11.6048L5.07498 17.3862C4.41411 18.162 3.23201 18.2093 2.51138 17.4886C1.79074 16.768 1.83795 15.5859 2.61376 14.925L8.3953 10", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const Legal01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Legal01IconData,
  displayName: 'Legal01Icon',
});

const Legal02IconData = [
  ['path', { d: "M13 21L14.7031 18.4453C14.8886 18.1671 15.2008 18 15.5352 18H18.4648C18.7992 18 19.1114 18.1671 19.2969 18.4453L21 21M12 21H22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 9.79771L4.39233 10.4915C3.10311 10.5846 1.99999 9.66543 2 8.49806C2.00001 7.33069 3.10316 6.41145 4.39238 6.50454L14 7.1982", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14 3C13.6694 4.81843 13.5002 6.65921 13.5002 8.5C13.5002 10.3408 13.6694 12.1816 14 14M14 3H13.0002M14 3H20M14 14H13.0002M14 14H20M20 3C20.3306 4.81843 20.4959 6.65921 20.4959 8.5C20.4959 10.3408 20.3306 12.1816 20 14M20 3H21.0002M20 14H21.0002", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Legal02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Legal02IconData,
  displayName: 'Legal02Icon',
});

const LegalDocument01IconData = [
  ['path', { d: "M3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V5C21 3.34315 19.6569 2 18 2H6C4.34315 2 3 3.34315 3 5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.5 10.5005L8.5 13.5M12.0002 6.00012L16.0005 10.0005L13.5004 12.5006L9.5 8.5003L12.0002 6.00012Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8.5 18H15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LegalDocument01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LegalDocument01IconData,
  displayName: 'LegalDocument01Icon',
});

const LegalDocument02IconData = [
  ['path', { d: "M6.5 7H12M12 7H17.5M12 7V14M12 14H10.5M12 14H13.5M8 7L9.24598 9.00385C9.90942 10.0708 9.19603 11.5 8 11.5C6.80397 11.5 6.09058 10.0708 6.75402 9.00385L8 7ZM16 7L17.246 9.00385C17.9094 10.0708 17.196 11.5 16 11.5C14.804 11.5 14.0906 10.0708 14.754 9.00385L16 7Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V5C21 3.34315 19.6569 2 18 2H6Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8.5 17H15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LegalDocument02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LegalDocument02IconData,
  displayName: 'LegalDocument02Icon',
});

const LegalHammerIconData = [
  ['path', { d: "M11.5 12L13.5 14L16 11.5L12 7.5L9.5 10L11.5 12ZM11.5 12L9 14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 11.0511V6.12325C21 5.34825 20.4145 4.70502 19.6551 4.57302C16.595 4.04108 14.0546 2.85772 12.8152 2.20154C12.3077 1.93282 11.6923 1.93282 11.1848 2.20154C9.94542 2.85772 7.40502 4.04108 4.34489 4.57302C3.58552 4.70502 3 5.34825 3 6.12325V11.0511C3 17.4795 9.53762 20.9859 11.4689 21.8815C11.8097 22.0395 12.1903 22.0395 12.5311 21.8815C14.4624 20.9859 21 17.4795 21 11.0511Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const LegalHammerIcon = /* @__PURE__ */ createTerraIcon({
  icon: LegalHammerIconData,
  displayName: 'LegalHammerIcon',
});

const LessThanCircleIconData = [
  ['path', { d: "M13.5 9L10.5 12L13.5 15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['circle', { cx: 12, cy: 12, r: 10, stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
] as const;

export const LessThanCircleIcon = /* @__PURE__ */ createTerraIcon({
  icon: LessThanCircleIconData,
  displayName: 'LessThanCircleIcon',
});

const LessThanSquareIconData = [
  ['path', { d: "M4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.50044C21.5 3.39589 20.6046 2.50047 19.5001 2.50044L4.50005 2.50005C3.39546 2.50002 2.5 3.39546 2.5 4.50005V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.4998 8.5L9.99982 12L13.4998 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LessThanSquareIcon = /* @__PURE__ */ createTerraIcon({
  icon: LessThanSquareIconData,
  displayName: 'LessThanSquareIcon',
});

const LessThanIconData = [
  ['path', { d: "M17 4L7 12L17 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const LessThanIcon = /* @__PURE__ */ createTerraIcon({
  icon: LessThanIconData,
  displayName: 'LessThanIcon',
});

const LetterSpacingIconData = [
  ['path', { d: "M2 22V2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 22V2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16.9976 18L15.1179 13.5M7 18L8.86945 13.5M15.1179 13.5L11.9852 6L8.86945 13.5M15.1179 13.5H8.86945", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LetterSpacingIcon = /* @__PURE__ */ createTerraIcon({
  icon: LetterSpacingIconData,
  displayName: 'LetterSpacingIcon',
});

const LibrariesIconData = [
  ['path', { d: "M6.5 4H3.5C2.94772 4 2.5 4.44772 2.5 5V19C2.5 19.5523 2.94772 20 3.5 20H6.5C7.05228 20 7.5 19.5523 7.5 19V5C7.5 4.44772 7.05228 4 6.5 4Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M11.5 7H8.5C7.94772 7 7.5 7.44772 7.5 8V19C7.5 19.5523 7.94772 20 8.5 20H11.5C12.0523 20 12.5 19.5523 12.5 19V8C12.5 7.44772 12.0523 7 11.5 7Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M16.7736 7.0724L13.6306 8.33505C13.1329 8.53497 12.8798 9.09237 13.0559 9.60059L16.4252 19.3237C16.6066 19.847 17.175 20.1249 17.6973 19.9455L20.8215 18.8723C21.3446 18.6926 21.6242 18.1218 21.4465 17.5962L18.0961 7.68366C17.9113 7.13703 17.3075 6.85794 16.7736 7.0724Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
] as const;

export const LibrariesIcon = /* @__PURE__ */ createTerraIcon({
  icon: LibrariesIconData,
  displayName: 'LibrariesIcon',
});

const LibraryIconData = [
  ['path', { d: "M10.5001 20V5C10.5001 4.17157 9.8285 3.5 9.00007 3.5H4.00006C3.17164 3.5 2.50007 4.17157 2.50006 4.99999L2.5 20C2.5 20.8284 3.17157 21.5 4 21.5H9.00007C9.8285 21.5 10.5001 20.8284 10.5001 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6.63477 18H6.50977M6.75977 18C6.75977 18.1381 6.64784 18.25 6.50977 18.25C6.37169 18.25 6.25977 18.1381 6.25977 18C6.25977 17.8619 6.37169 17.75 6.50977 17.75C6.64784 17.75 6.75977 17.8619 6.75977 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20.2498 20.7142C21.053 20.587 21.6052 19.8049 21.4831 18.9674L19.2731 3.80356C19.151 2.96609 18.4009 2.39035 17.5978 2.51762L12.7502 3.28576C11.947 3.41303 11.3948 4.19511 11.5169 5.03258L13.7269 20.1964C13.8489 21.0339 14.599 21.6096 15.4022 21.4824L20.2498 20.7142Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M19.5187 6.61719L12 7.99955", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M2.5 7.5H10.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M17.625 18H17.5M17.75 18C17.75 18.1381 17.6381 18.25 17.5 18.25C17.3619 18.25 17.25 18.1381 17.25 18C17.25 17.8619 17.3619 17.75 17.5 17.75C17.6381 17.75 17.75 17.8619 17.75 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
] as const;

export const LibraryIcon = /* @__PURE__ */ createTerraIcon({
  icon: LibraryIconData,
  displayName: 'LibraryIcon',
});

const LicenseDraftIconData = [
  ['path', { d: "M10.5 22H4.50002C3.39544 22 2.50001 21.1046 2.50002 20L2.50016 3.99998C2.50017 2.89542 3.39559 2 4.50016 2H17.5C18.6046 2 19.5 2.89543 19.5 4V11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 7H15M7 12H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M13.5 20V22H15.5L21.5 16L19.5 14L13.5 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const LicenseDraftIcon = /* @__PURE__ */ createTerraIcon({
  icon: LicenseDraftIconData,
  displayName: 'LicenseDraftIcon',
});

const LicenseMaintenanceIconData = [
  ['path', { d: "M11 22H4.50002C3.39544 22 2.50001 21.1046 2.50002 20L2.50016 3.99998C2.50017 2.89542 3.39559 2 4.50016 2H17.5C18.6046 2 19.5 2.89543 19.5 4V10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 7H15M7 12H11.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M17.5 20.7727C19.2673 20.7727 20.7 19.3075 20.7 17.5C20.7 15.6925 19.2673 14.2273 17.5 14.2273M17.5 20.7727C15.7327 20.7727 14.3 19.3075 14.3 17.5C14.3 15.6925 15.7327 14.2273 17.5 14.2273M17.5 20.7727V22M17.5 14.2273V13M14.5913 15.7149L13.5004 15.0455M21.5 19.9545L20.4092 19.2851M20.4087 15.7149L21.4996 15.0455M13.5 19.9545L14.5908 19.2851", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
] as const;

export const LicenseMaintenanceIcon = /* @__PURE__ */ createTerraIcon({
  icon: LicenseMaintenanceIconData,
  displayName: 'LicenseMaintenanceIcon',
});

const LicenseNoIconData = [
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3.5 3.5L3.5 20C3.49999 21.1046 4.39542 22 5.5 22H18.5C19.4501 22 20.2454 21.3375 20.4493 20.4493M8.49998 17H16.5M8.49998 12H12M5.99998 2H18.5C19.6046 2 20.5 2.89543 20.5 4V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LicenseNoIcon = /* @__PURE__ */ createTerraIcon({
  icon: LicenseNoIconData,
  displayName: 'LicenseNoIcon',
});

const LicensePinIconData = [
  ['path', { d: "M7 7H15M7 12H12.5M7 17L11 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.5 22H4.50002C3.39544 22 2.50001 21.1046 2.50002 20L2.50016 3.99998C2.50017 2.89542 3.39559 2 4.50016 2H17.5C18.6046 2 19.5 2.89543 19.5 4V10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18.5 19H15.5L17 16.5L16.5 14H20.5L20 16.5L21.5 19H18.5ZM18.5 19V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LicensePinIcon = /* @__PURE__ */ createTerraIcon({
  icon: LicensePinIconData,
  displayName: 'LicensePinIcon',
});

const LicenseThirdPartyIconData = [
  ['path', { d: "M21.5 21.9999H14.5C14.5 20.0669 16.067 18.4999 18 18.4999C19.933 18.4999 21.5 20.0669 21.5 21.9999Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19.75 14.7499C19.75 15.7164 18.9665 16.4999 18 16.4999C17.0335 16.4999 16.25 15.7164 16.25 14.7499C16.25 13.7834 17.0335 12.9999 18 12.9999C18.9665 12.9999 19.75 13.7834 19.75 14.7499Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 21.9999H4.50002C3.39544 21.9999 2.50001 21.1044 2.50002 19.9999L2.50016 3.99986C2.50017 2.8953 3.39559 1.99988 4.50016 1.99988H17.5C18.6046 1.99988 19.5 2.89531 19.5 3.99988V9.99988", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M7 6.99988H15M7 11.9999H13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "3" }],
] as const;

export const LicenseThirdPartyIcon = /* @__PURE__ */ createTerraIcon({
  icon: LicenseThirdPartyIconData,
  displayName: 'LicenseThirdPartyIcon',
});

const LicenseIconData = [
  ['path', { d: "M20.5 20V4C20.5 2.89543 19.6046 2 18.5 2H5.50016C4.39559 2 3.50017 2.89542 3.50016 3.99998L3.50002 20C3.50001 21.1046 4.39544 22 5.50002 22H18.5C19.6046 22 20.5 21.1046 20.5 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 7H16M8 12H16M8 17L12 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LicenseIcon = /* @__PURE__ */ createTerraIcon({
  icon: LicenseIconData,
  displayName: 'LicenseIcon',
});

const LifebuoyIconData = [
  ['path', { d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 7V3M12 17V21M17 12H21M7 12H3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M14.8965 3.47625C15.63 2.57541 16.7478 2 18 2C20.2091 2 22 3.79086 22 6C22 7.25222 21.4246 8.37005 20.5238 9.1035M20.5238 14.8965C21.4246 15.63 22 16.7478 22 18C22 20.2091 20.2091 22 18 22C16.7478 22 15.63 21.4246 14.8965 20.5238M9.1035 20.5238C8.37005 21.4246 7.25222 22 6 22C3.79086 22 2 20.2091 2 18C2 16.7478 2.57541 15.63 3.47625 14.8965M3.47625 9.1035C2.57541 8.37005 2 7.25222 2 6C2 3.79086 3.79086 2 6 2C7.25222 2 8.37005 2.57541 9.1035 3.47625", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LifebuoyIcon = /* @__PURE__ */ createTerraIcon({
  icon: LifebuoyIconData,
  displayName: 'LifebuoyIcon',
});

const LiftTruckIconData = [
  ['path', { d: "M20 4V13M22 18H21C20.4477 18 20 17.5523 20 17V13M20 13H18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 17.5C7 18.8807 5.88071 20 4.5 20C3.11929 20 2 18.8807 2 17.5C2 16.1193 3.11929 15 4.5 15C5.88071 15 7 16.1193 7 17.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M17 17.5C17 18.8807 15.8807 20 14.5 20C13.1193 20 12 18.8807 12 17.5C12 16.1193 13.1193 15 14.5 15C15.8807 15 17 16.1193 17 17.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M4 9H7C7.62951 9 8.22229 9.29639 8.6 9.8L10.4 12.2C10.7777 12.7036 11.3705 13 12 13H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M4 15V5C4 4.44771 4.44772 4 5 4H9.64922C9.87629 4 10.0966 4.07728 10.2739 4.21913L14.6247 7.69976C14.8619 7.88953 15 8.17684 15 8.48062V15M7 17.5H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LiftTruckIcon = /* @__PURE__ */ createTerraIcon({
  icon: LiftTruckIconData,
  displayName: 'LiftTruckIcon',
});

const LigatureIconData = [
  ['path', { d: "M15 5.35418C14.2671 4.52375 13.1947 4 12 4C9.79086 4 8 5.79086 8 8V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6 20H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6 12H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M14 13L16 12V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M14 20H18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LigatureIcon = /* @__PURE__ */ createTerraIcon({
  icon: LigatureIconData,
  displayName: 'LigatureIcon',
});

const LightbulbOffIconData = [
  ['path', { d: "M5.14286 14C4.41735 12.8082 4 11.4118 4 9.91886C4 8.24668 4.52361 6.69556 5.41738 5.41738M8.03786 3.03786C9.20596 2.37741 10.5585 2 12 2C16.4183 2 20 5.5454 20 9.91886C20 11.3746 19.6032 12.7386 18.9107 13.9107", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.9236 16H7L7.77208 18.3162C7.90819 18.7246 8.29033 19 8.72076 19L15.2792 19C15.7097 19 16.0918 18.7246 16.2279 18.3162L16.7309 16.8073", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 19L14.2279 21.3162C14.0918 21.7246 13.7097 22 13.2792 22H10.7208C10.2903 22 9.90819 21.7246 9.77208 21.3162L9 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 15.5V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LightbulbOffIcon = /* @__PURE__ */ createTerraIcon({
  icon: LightbulbOffIconData,
  displayName: 'LightbulbOffIcon',
});

const LighthouseIconData = [
  ['path', { d: "M10.0195 8C9.32545 7.06743 8.14285 5.76203 8.60385 4.47631C8.91057 3.62086 11.0067 2 12 2C12.9933 2 15.0894 3.62086 15.3962 4.47631C15.8572 5.76203 14.6745 7.06743 13.9805 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 8H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 13H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M7.5 18H16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M9.5 8L7 22M14.5 8L17 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M5 22H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M19 7.5L21 7M19 10.5L21 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
  ['path', { d: "M5 7.5L3 7M5 10.5L3 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "7" }],
] as const;

export const LighthouseIcon = /* @__PURE__ */ createTerraIcon({
  icon: LighthouseIconData,
  displayName: 'LighthouseIcon',
});

const LimitOrderIconData = [
  ['circle', { cx: 12, cy: 14, r: 3, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 11.5L5.5 7H3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 13.9998V14.0098M21 13.99V14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M3 14V14.01M6 14.01V14.02", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M12 13.99V14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LimitOrderIcon = /* @__PURE__ */ createTerraIcon({
  icon: LimitOrderIconData,
  displayName: 'LimitOrderIcon',
});

const LimitationIconData = [
  ['path', { d: "M13.5 10.5L18 5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['circle', { cx: 12, cy: 12, r: 1.5, stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16 18.999L18.001 21C20.4293 19.1755 22 16.2712 22 13C22 7.47715 17.5228 3 12 3C6.47715 3 2 7.47715 2 13C2 16.2712 3.57069 19.1755 5.99902 21L8 18.999", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LimitationIcon = /* @__PURE__ */ createTerraIcon({
  icon: LimitationIconData,
  displayName: 'LimitationIcon',
});

const LineIconData = [
  ['path', { d: "M6 8.50391V12.5H7M9 8.5V12.5M11 12.5V8.5L13.5 12.5V8.5M17.5 8.5L15.5 8.50391V10.5051M15.5 10.5051V12.5H17.5M15.5 10.5051H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2.03906 10.6146C2.03906 15.4271 7.05919 19.9581 13.9513 18.8296V21.973C13.9513 21.9815 13.9605 21.9866 13.967 21.9812C14.0924 21.8767 14.9342 21.1731 15.2122 20.8615C17.338 18.4788 21.9054 14.8849 22.0349 10.6146C22.0349 5.80212 17.5846 1.98145 12.0629 1.98145C6.54121 1.98145 2.03906 5.80212 2.03906 10.6146Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LineIcon = /* @__PURE__ */ createTerraIcon({
  icon: LineIconData,
  displayName: 'LineIcon',
});

const LinerIconData = [
  ['path', { d: "M3 20L21 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const LinerIcon = /* @__PURE__ */ createTerraIcon({
  icon: LinerIconData,
  displayName: 'LinerIcon',
});

const Link01IconData = [
  ['path', { d: "M9.14339 10.691L9.35031 10.4841C11.329 8.50532 14.5372 8.50532 16.5159 10.4841C18.4947 12.4628 18.4947 15.671 16.5159 17.6497L13.6497 20.5159C11.671 22.4947 8.46279 22.4947 6.48405 20.5159C4.50532 18.5372 4.50532 15.329 6.48405 13.3503L6.9484 12.886", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17.0516 11.114L17.5159 10.6497C19.4947 8.67095 19.4947 5.46279 17.5159 3.48405C15.5372 1.50532 12.329 1.50532 10.3503 3.48405L7.48405 6.35031C5.50532 8.32904 5.50532 11.5372 7.48405 13.5159C9.46279 15.4947 12.671 15.4947 14.6497 13.5159L14.8566 13.309", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Link01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Link01IconData,
  displayName: 'Link01Icon',
});

const Link02IconData = [
  ['path', { d: "M9.5 14.5L14.5 9.49995", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16.8463 14.6095L19.4558 12C21.5147 9.94108 21.5147 6.60298 19.4558 4.54411C17.397 2.48524 14.0589 2.48524 12 4.54411L9.39045 7.15366M14.6095 16.8463L12 19.4558C9.94113 21.5147 6.60303 21.5147 4.54416 19.4558C2.48528 17.3969 2.48528 14.0588 4.54416 12L7.1537 9.39041", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Link02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Link02IconData,
  displayName: 'Link02Icon',
});

const Link03IconData = [
  ['path', { d: "M10 14L15 9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.5 15.5C13.0523 16.0523 13.0523 16.9477 12.5 17.5L8.91422 21.0858C8.13317 21.8668 6.86684 21.8668 6.08579 21.0858L2.91422 17.9142C2.13317 17.1332 2.13317 15.8668 2.91422 15.0858L6.5 11.5C7.05229 10.9477 7.94772 10.9477 8.5 11.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11.5 8.5C10.9477 7.94771 10.9477 7.05228 11.5 6.5L15.0858 2.91421C15.8668 2.13316 17.1331 2.13316 17.9142 2.91421L21.0858 6.08579C21.8668 6.86683 21.8668 8.13316 21.0858 8.91421L17.5 12.5C16.9477 13.0523 16.0523 13.0523 15.5 12.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Link03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Link03IconData,
  displayName: 'Link03Icon',
});

const Link04IconData = [
  ['path', { d: "M10 13.229C10.1416 13.4609 10.3097 13.6804 10.5042 13.8828C11.7117 15.1395 13.5522 15.336 14.9576 14.4722C15.218 14.3121 15.4634 14.1157 15.6872 13.8828L18.9266 10.5114C20.3578 9.02184 20.3578 6.60676 18.9266 5.11718C17.4953 3.6276 15.1748 3.62761 13.7435 5.11718L13.03 5.85978", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10.9703 18.14L10.2565 18.8828C8.82526 20.3724 6.50471 20.3724 5.07345 18.8828C3.64218 17.3932 3.64218 14.9782 5.07345 13.4886L8.31287 10.1172C9.74413 8.62761 12.0647 8.6276 13.4959 10.1172C13.6904 10.3195 13.8584 10.539 14 10.7708", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Link04Icon = /* @__PURE__ */ createTerraIcon({
  icon: Link04IconData,
  displayName: 'Link04Icon',
});

const Link05IconData = [
  ['path', { d: "M13.5 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H13.5M10.5 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H10.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.5 12H15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Link05Icon = /* @__PURE__ */ createTerraIcon({
  icon: Link05IconData,
  displayName: 'Link05Icon',
});

const Link06IconData = [
  ['path', { d: "M14 13V9C14 8.44772 13.5523 8 13 8H7C6.44772 8 6 8.44772 6 9V20C6 20.5523 6.44772 21 7 21H13C13.5523 21 14 20.5523 14 20V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 11V15C10 15.5523 10.4477 16 11 16H17C17.5523 16 18 15.5523 18 15V4C18 3.44772 17.5523 3 17 3H11C10.4477 3 10 3.44772 10 4V5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Link06Icon = /* @__PURE__ */ createTerraIcon({
  icon: Link06IconData,
  displayName: 'Link06Icon',
});

const LinkBackwardIconData = [
  ['path', { d: "M11 8.5H10.5V4L3 11.5L10.5 19V14.5C17 14.5 21 20 21 20V18.5C21 12.9772 16.5228 8.5 11 8.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
] as const;

export const LinkBackwardIcon = /* @__PURE__ */ createTerraIcon({
  icon: LinkBackwardIconData,
  displayName: 'LinkBackwardIcon',
});

const LinkCircle02IconData = [
  ['path', { d: "M21.0001 12C21.0001 16.9706 16.9707 21 12.0001 21C7.0295 21 3.00006 16.9706 3.00006 12C3.00006 7.02944 7.0295 3 12.0001 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.0001 12.9995L20.3836 3.61697M21.0012 8V3H16.0011", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LinkCircle02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LinkCircle02IconData,
  displayName: 'LinkCircle02Icon',
});

const LinkCircleIconData = [
  ['path', { d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 9L20.4986 3.50019M20.9986 8V3H15.9976", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LinkCircleIcon = /* @__PURE__ */ createTerraIcon({
  icon: LinkCircleIconData,
  displayName: 'LinkCircleIcon',
});

const LinkForwardIconData = [
  ['path', { d: "M13 8.5H13.5V4L21 11.5L13.5 19V14.5C7 14.5 3 20 3 20V18.5C3 12.9772 7.47715 8.5 13 8.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
] as const;

export const LinkForwardIcon = /* @__PURE__ */ createTerraIcon({
  icon: LinkForwardIconData,
  displayName: 'LinkForwardIcon',
});

const LinkSquare01IconData = [
  ['path', { d: "M10.5 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 9L20.4547 3.54566M20.9989 9L21 3H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LinkSquare01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LinkSquare01IconData,
  displayName: 'LinkSquare01Icon',
});

const LinkSquare02IconData = [
  ['path', { d: "M10.5 3H4.99995C3.89538 3 2.99995 3.89543 2.99995 5V19C2.99995 20.1046 3.89538 21 4.99995 21H19C20.1045 21 21 20.1046 21 19V13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11 13L20.3499 3.64944M21 9V3L15 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LinkSquare02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LinkSquare02IconData,
  displayName: 'LinkSquare02Icon',
});

const Linkedin01IconData = [
  ['path', { d: "M21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 10V17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 13V17M11 13C11 11.3431 12.3431 10 14 10C15.6569 10 17 11.3431 17 13V17M11 13V10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M7.125 6.75H7M7.25 6.75C7.25 6.88807 7.13807 7 7 7C6.86193 7 6.75 6.88807 6.75 6.75C6.75 6.61193 6.86193 6.5 7 6.5C7.13807 6.5 7.25 6.61193 7.25 6.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const Linkedin01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Linkedin01IconData,
  displayName: 'Linkedin01Icon',
});

const Linkedin02IconData = [
  ['path', { d: "M6.5 9.5H2V22H6.5V9.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6.5 4.25C6.5 5.49264 5.49264 6.5 4.25 6.5C3.00736 6.5 2 5.49264 2 4.25C2 3.00736 3.00736 2 4.25 2C5.49264 2 6.5 3.00736 6.5 4.25Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.0001 9.5H9.5V22H14.0001V15.7502C14.0001 14.7837 14.7835 14.0002 15.75 14.0002C16.7165 14.0002 17.5 14.7837 17.5 15.7502V22H21.9987L22.0001 14.0002C22.0001 11.515 19.6364 9.50024 17.2968 9.50024C15.9649 9.50024 14.7767 10.1531 14.0001 11.174V9.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const Linkedin02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Linkedin02IconData,
  displayName: 'Linkedin02Icon',
});

const ListChevronsDownUpIconData = [
  ['path', { d: "M15 6L18 9L21 6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 18L18 15L21 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 6H3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M11 12H3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M11 18H3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const ListChevronsDownUpIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListChevronsDownUpIconData,
  displayName: 'ListChevronsDownUpIcon',
});

const ListFilterPlusIconData = [
  ['path', { d: "M3 7.49805H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 7.49768L21 7.49769M17.995 10.502L17.995 4.50195", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6 13.498H18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M9 19.498H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const ListFilterPlusIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListFilterPlusIconData,
  displayName: 'ListFilterPlusIcon',
});

const ListIndentDecreaseIconData = [
  ['path', { d: "M7 8L3 12L7 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11 12H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 19H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M11 5H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const ListIndentDecreaseIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListIndentDecreaseIconData,
  displayName: 'ListIndentDecreaseIcon',
});

const ListIndentIncreaseIconData = [
  ['path', { d: "M2.99994 8L6.99994 12L2.99994 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11 12H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 19H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M11 5H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const ListIndentIncreaseIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListIndentIncreaseIconData,
  displayName: 'ListIndentIncreaseIcon',
});

const ListMusicIconData = [
  ['path', { d: "M2 5H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 12H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2 19H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M18 16V5C18 5 19 8.5 22 8.5M18 16C18 17.6569 16.6569 19 15 19C13.3431 19 12 17.6569 12 16C12 14.3431 13.3431 13 15 13C16.6569 13 18 14.3431 18 16Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const ListMusicIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListMusicIconData,
  displayName: 'ListMusicIcon',
});

const ListPlusIconData = [
  ['path', { d: "M3 5H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 12H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 12.0009H21M17.995 15.0059L17.995 9.00586", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M3 19H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const ListPlusIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListPlusIconData,
  displayName: 'ListPlusIcon',
});

const ListRestartIconData = [
  ['path', { d: "M3 4.5H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 11.5H8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3 18.5H8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12.2561 13.5C12.8738 11.7522 14.5407 10.5 16.5 10.5C18.9853 10.5 21 12.5147 21 15C21 17.4853 18.9853 19.5 16.5 19.5C14.9398 19.5 13.565 18.706 12.7578 17.5M12 9.5V13.5H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const ListRestartIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListRestartIconData,
  displayName: 'ListRestartIcon',
});

const ListSettingIconData = [
  ['path', { d: "M16.5 19.8571V21M16.5 19.8571C15.4878 19.8571 14.5961 19.3521 14.073 18.5852M16.5 19.8571C17.5122 19.8571 18.4039 19.3521 18.927 18.5852M16.5 14.1429C17.5123 14.1429 18.4041 14.648 18.9271 15.415M16.5 14.1429C15.4877 14.1429 14.5959 14.648 14.0729 15.415M16.5 14.1429V13M20 14.7143L18.9271 15.415M13.0004 19.2857L14.073 18.5852M13 14.7143L14.0729 15.415M19.9996 19.2857L18.927 18.5852M18.9271 15.415C19.2364 15.8685 19.4167 16.4136 19.4167 17C19.4167 17.5864 19.2363 18.1316 18.927 18.5852M14.0729 15.415C13.7636 15.8685 13.5833 16.4136 13.5833 17C13.5833 17.5864 13.7637 18.1316 14.073 18.5852", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M4 3H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M4 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M4 15H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "3" }],
] as const;

export const ListSettingIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListSettingIconData,
  displayName: 'ListSettingIcon',
});

const ListStartIconData = [
  ['path', { d: "M3 6H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16 3L13 6L16 9M13.5 6H19C20.1046 6 21 6.89543 21 8V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3 13H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M3 20H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const ListStartIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListStartIconData,
  displayName: 'ListStartIcon',
});

const ListTreeIconData = [
  ['path', { d: "M3 6V14C3 15.1046 3.89543 16 5 16H8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 4V6C3 7.10457 3.89543 8 5 8H8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 8H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 12H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M12 20H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M12 16H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
] as const;

export const ListTreeIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListTreeIconData,
  displayName: 'ListTreeIcon',
});

const ListVideoIconData = [
  ['path', { d: "M3 5H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 12H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3 19H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M14 11.7872V18.2128C14 18.6476 14.3524 19 14.7872 19C14.9266 19 15.0634 18.963 15.1838 18.8928L20.5681 15.7519C20.8355 15.5959 21 15.3096 21 15C21 14.6904 20.8355 14.4041 20.5681 14.2481L15.1838 11.1072C15.0634 11.037 14.9266 11 14.7872 11C14.3524 11 14 11.3524 14 11.7872Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const ListVideoIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListVideoIconData,
  displayName: 'ListVideoIcon',
});

const ListViewIconData = [
  ['path', { d: "M21 2H3C2.44772 2 2 2.44772 2 3V5C2 5.55228 2.44772 6 3 6H21C21.5523 6 22 5.55228 22 5V3C22 2.44772 21.5523 2 21 2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M21 10H3C2.44772 10 2 10.4477 2 11V13C2 13.5523 2.44772 14 3 14H21C21.5523 14 22 13.5523 22 13V11C22 10.4477 21.5523 10 21 10Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M21 18H3C2.44772 18 2 18.4477 2 19V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V19C22 18.4477 21.5523 18 21 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
] as const;

export const ListViewIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListViewIconData,
  displayName: 'ListViewIcon',
});

const ListXIconData = [
  ['path', { d: "M3 5H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 12H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16.0083 9.50391L18.5 11.9997M18.5 11.9997L21 14.5039M18.5 11.9997L16 14.5039M18.5 11.9997L20.9917 9.50391", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M3 19H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const ListXIcon = /* @__PURE__ */ createTerraIcon({
  icon: ListXIconData,
  displayName: 'ListXIcon',
});

const LitecoinIconData = [
  ['path', { d: "M12 2C6.47716 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M13 7L10 16H15M9 12.5L13.5 11.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LitecoinIcon = /* @__PURE__ */ createTerraIcon({
  icon: LitecoinIconData,
  displayName: 'LitecoinIcon',
});

const LiveStreaming01IconData = [
  ['path', { d: "M20 20.5C21.1046 20.5 22 19.6046 22 18.5V12.5C22 11.3954 21.1046 10.5 20 10.5H4C2.89543 10.5 2 11.3954 2 12.5V18.5C2 19.6046 2.89543 20.5 4 20.5H20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16 5.5C15.0227 4.27354 13.5929 3.5 12 3.5C10.4071 3.5 8.97726 4.27354 8 5.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M14 7.5C13.5114 6.88677 12.7965 6.5 12 6.5C11.2035 6.5 10.4886 6.88677 10 7.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M5 13.5V17.5H6.5M19 17.5H17V15.5M17 15.5V13.5H19M17 15.5H18.5M9 13.5V17.5M11.5 13.5L13 17.5L14.5 13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LiveStreaming01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LiveStreaming01IconData,
  displayName: 'LiveStreaming01Icon',
});

const LiveStreaming02IconData = [
  ['circle', { cx: 12, cy: 12, r: 2, stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M7.5 8C6.5 9 6 10.5 6 12C6 13.5 6.5 15 7.5 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M4.5 6C3 7.5 2 9.5 2 12C2 14.5 3 16.5 4.5 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M16.5 16C17.5 15 18 13.5 18 12C18 10.5 17.5 9 16.5 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M19.5 18C21 16.5 22 14.5 22 12C22 9.5 21 7.5 19.5 6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LiveStreaming02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LiveStreaming02IconData,
  displayName: 'LiveStreaming02Icon',
});

const LiveStreaming03IconData = [
  ['path', { d: "M4 4.5H15C16.1046 4.5 17 5.39543 17 6.5V17.5C17 18.6046 16.1046 19.5 15 19.5H4C2.89543 19.5 2 18.6046 2 17.5V6.5C2 5.39543 2.89543 4.5 4 4.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17 13V11L20.1917 7.35236C20.3876 7.12844 20.6707 7 20.9682 7C21.538 7 22 7.46195 22 8.0318V15.9682C22 16.538 21.538 17 20.9682 17C20.6707 17 20.3876 16.8716 20.1917 16.6476L17 13Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.5 13.5C10.3284 13.5 11 12.8284 11 12C11 11.1716 10.3284 10.5 9.5 10.5M9.5 13.5C8.67157 13.5 8 12.8284 8 12C8 11.1716 8.67157 10.5 9.5 10.5M9.5 13.5V10.5", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
] as const;

export const LiveStreaming03Icon = /* @__PURE__ */ createTerraIcon({
  icon: LiveStreaming03IconData,
  displayName: 'LiveStreaming03Icon',
});

const LiverIconData = [
  ['path', { d: "M18 8.03446C15.1204 8.03446 13.127 5.01107 10 5.01107C5.58172 5.01107 2 8.62072 2 13.0735C2 14.5065 2.17145 16.2117 2.8675 17.6086C3.41433 18.7061 4.68138 19.1636 5.88098 18.9481C10.4299 18.1308 14 15.0032 15 13.0047M15 13.0047C13.2314 13.1113 11 12.5051 9 11.0579M15 13.0047C17.8307 12.8342 22 10.2093 22 7.02666C22 3.84398 17 5.01107 14 6.46669", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const LiverIcon = /* @__PURE__ */ createTerraIcon({
  icon: LiverIconData,
  displayName: 'LiverIcon',
});

const LoaderPinwheelIconData = [
  ['circle', { cx: 12, cy: 12, r: 9, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.99997 3.51721C9.58182 3.47053 10.1737 3.51405 10.7492 3.65094C12.05 3.96034 13.1607 4.72137 13.837 5.76663C14.5133 6.81189 14.6998 8.05575 14.3555 9.22457C14.0112 10.3934 13.1642 11.3914 12.001 11.9991C10.8378 12.6069 9.99082 13.6049 9.6465 14.7737C9.30219 15.9425 9.48869 17.1864 10.165 18.2317C10.8413 19.2769 11.952 20.038 13.2527 20.3473C13.8276 20.4841 14.4188 20.5277 15 20.4812", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M17.8456 5.16003C18.1769 5.6406 18.4352 6.17494 18.6044 6.74182C18.9868 8.023 18.8831 9.36541 18.316 10.4737C17.7489 11.5821 16.765 12.3655 15.5806 12.6517C14.3962 12.938 13.1084 12.7035 12.0005 12C10.8926 11.2964 9.60479 11.062 8.4204 11.3482C7.23601 11.6344 6.25205 12.4179 5.68498 13.5262C5.11792 14.6345 5.01419 15.9769 5.39662 17.2581C5.56564 17.8243 5.82348 18.3581 6.15427 18.8382", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M20.8459 13.6421C20.5954 14.1693 20.2618 14.6602 19.8554 15.0901C18.9371 16.0619 17.7227 16.6433 16.4793 16.7064C15.236 16.7694 14.0655 16.309 13.2254 15.4264C12.3853 14.5438 11.9445 13.3113 11.9998 12.0001C12.0551 10.6888 11.6143 9.45635 10.7742 8.57375C9.93413 7.69115 8.76366 7.23074 7.52029 7.29381C6.27692 7.35687 5.06249 7.93825 4.14417 8.91004C3.73833 9.33951 3.40501 9.82969 3.1546 10.3562", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LoaderPinwheelIcon = /* @__PURE__ */ createTerraIcon({
  icon: LoaderPinwheelIconData,
  displayName: 'LoaderPinwheelIcon',
});

const Loading01IconData = [
  ['path', { d: "M20 4.23052V4C20 2.89543 19.1046 2 18 2H6C4.89543 2 4 2.89543 4 4V4.23052C4 5.3575 4.47541 6.43219 5.30931 7.19028L8.76006 10.3273C9.23133 10.7558 9.5 11.3631 9.5 12C9.5 12.6369 9.23133 13.2442 8.76006 13.6727L5.30931 16.8097C4.47541 17.5678 4 18.6425 4 19.7695V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V19.7695C20 18.6425 19.5246 17.5678 18.6907 16.8097L15.2399 13.6727C14.7687 13.2442 14.5 12.6369 14.5 12C14.5 11.3631 14.7687 10.7558 15.2399 10.3273L18.6907 7.19028C19.5246 6.43219 20 5.3575 20 4.23052Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 21.6381C9 21.1962 9 20.9752 9.0876 20.7821C9.10151 20.7514 9.11699 20.7214 9.13399 20.6923C9.24101 20.509 9.42211 20.3796 9.78432 20.1208C10.7905 19.4021 11.2935 19.0427 11.8652 19.0045C11.955 18.9985 12.045 18.9985 12.1348 19.0045C12.7065 19.0427 13.2095 19.4021 14.2157 20.1208C14.5779 20.3796 14.759 20.509 14.866 20.6923C14.883 20.7214 14.8985 20.7514 14.9124 20.7821C15 20.9752 15 21.1962 15 21.6381V22H9V21.6381Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const Loading01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Loading01IconData,
  displayName: 'Loading01Icon',
});

const Loading02IconData = [
  ['path', { d: "M18.001 20C16.3295 21.2558 14.2516 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.8634 21.8906 13.7011 21.6849 14.5003L18.802 13.66C18.9314 13.1279 19 12.572 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.3197 19 14.554 18.6348 15.6076 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const Loading02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Loading02IconData,
  displayName: 'Loading02Icon',
});

const Loading03IconData = [
  ['path', { d: "M12 3V6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M12 18V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M21 12H18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M6 12H3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "3" }],
  ['path', { d: "M18.3635 5.63672L16.2422 7.75804", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "4" }],
  ['path', { d: "M7.75804 16.2422L5.63672 18.3635", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "5" }],
  ['path', { d: "M18.3635 18.3635L16.2422 16.2422", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "6" }],
  ['path', { d: "M7.75804 7.75804L5.63672 5.63672", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "7" }],
] as const;

export const Loading03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Loading03IconData,
  displayName: 'Loading03Icon',
});

const Loading04IconData = [
  ['path', { d: "M3 10H21C21.5523 10 22 10.4477 22 11V13C22 13.5523 21.5523 14 21 14H3C2.44772 14 2 13.5523 2 13V11C2 10.4477 2.44772 10 3 10Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 14V10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Loading04Icon = /* @__PURE__ */ createTerraIcon({
  icon: Loading04IconData,
  displayName: 'Loading04Icon',
});

const Location01IconData = [
  ['path', { d: "M15.5 11C15.5 12.933 13.933 14.5 12 14.5C10.067 14.5 8.5 12.933 8.5 11C8.5 9.067 10.067 7.5 12 7.5C13.933 7.5 15.5 9.067 15.5 11Z", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const Location01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location01IconData,
  displayName: 'Location01Icon',
});

const Location02IconData = [
  ['path', { d: "M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
] as const;

export const Location02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location02IconData,
  displayName: 'Location02Icon',
});

const Location03IconData = [
  ['path', { d: "M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18.5 17.5L19.875 20.5939C20.169 21.2551 19.6849 22 18.9612 22H4.97681C4.2694 22 3.78565 21.2856 4.04828 20.6287L5.49918 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M19 9.2C19 13.9809 13.8979 17.0126 12.4054 17.7971C12.1485 17.9322 11.8515 17.9322 11.5946 17.7971C10.1021 17.0126 5 13.9809 5 9.2C5 5.22355 8.13401 2 12 2C15.866 2 19 5.22355 19 9.2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Location03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location03IconData,
  displayName: 'Location03Icon',
});

const Location04IconData = [
  ['path', { d: "M6 18C4.75527 18.396 4 19.184 4 19.7537C4 20.9943 7.58172 22 12 22C16.4183 22 20 20.9943 20 19.7537C20 19.184 19.2447 18.396 18 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M19 9.2C19 13.9809 13.8979 17.0126 12.4054 17.7971C12.1485 17.9322 11.8515 17.9322 11.5946 17.7971C10.1021 17.0126 5 13.9809 5 9.2C5 5.22355 8.13401 2 12 2C15.866 2 19 5.22355 19 9.2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Location04Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location04IconData,
  displayName: 'Location04Icon',
});

const Location05IconData = [
  ['path', { d: "M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 9.2C19 13.9809 13.8979 17.0126 12.4054 17.7971C12.1485 17.9322 11.8515 17.9322 11.5946 17.7971C10.1021 17.0126 5 13.9809 5 9.2C5 5.22355 8.13401 2 12 2C15.866 2 19 5.22355 19 9.2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 19C18 20.6569 15.3137 22 12 22C8.68629 22 6 20.6569 6 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Location05Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location05IconData,
  displayName: 'Location05Icon',
});

const Location06IconData = [
  ['path', { d: "M15.5 10.8887C15.5 12.8217 13.933 14.3887 12 14.3887C10.067 14.3887 8.5 12.8217 8.5 10.8887C8.5 8.95571 10.067 7.3887 12 7.3887C13.933 7.3887 15.5 8.95571 15.5 10.8887Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2.3887C7.30558 2.3887 3.5 6.00656 3.5 10.4694C3.5 15.3299 8.21916 17.7579 11.1092 21.1947C11.5669 21.7389 12.4531 21.7533 12.9211 21.2179C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00656 16.6944 2.3887 12 2.3887Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const Location06Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location06IconData,
  displayName: 'Location06Icon',
});

const Location07IconData = [
  ['path', { d: "M12 2.3887C7.30558 2.3887 3.5 6.00656 3.5 10.4694C3.5 15.3299 8.21916 17.7579 11.1092 21.1947C11.5669 21.7389 12.4531 21.7533 12.9211 21.2179C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00656 16.6944 2.3887 12 2.3887Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
] as const;

export const Location07Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location07IconData,
  displayName: 'Location07Icon',
});

const Location08IconData = [
  ['path', { d: "M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18.5 17.5L19.875 20.5939C20.169 21.2551 19.6849 22 18.9612 22H4.97681C4.2694 22 3.78565 21.2856 4.04828 20.6287L5.49918 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 2C8.13401 2 5 5.07518 5 8.8686C5 12.8958 8.6928 14.9584 11.0836 17.7656C11.5528 18.3166 12.468 18.3311 12.946 17.7878C15.374 15.0281 19 12.8174 19 8.8686C19 5.07518 15.866 2 12 2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const Location08Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location08IconData,
  displayName: 'Location08Icon',
});

const Location09IconData = [
  ['path', { d: "M5.5 18C4.55596 18.3952 4 19.0686 4 19.5925C4 20.9221 7.58172 22 12 22C16.4183 22 20 20.9221 20 19.5925C20 19.0686 19.444 18.3952 18.5 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 2C8.13401 2 5 5.07518 5 8.8686C5 12.8958 8.6928 14.9584 11.0836 17.7656C11.5528 18.3166 12.468 18.3311 12.946 17.7878C15.374 15.0281 19 12.8174 19 8.8686C19 5.07518 15.866 2 12 2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const Location09Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location09IconData,
  displayName: 'Location09Icon',
});

const Location10IconData = [
  ['path', { d: "M18 19C18 20.6569 15.3137 22 12 22C8.68629 22 6 20.6569 6 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 2C8.13401 2 5 5.07518 5 8.8686C5 12.8958 8.6928 14.9584 11.0836 17.7656C11.5528 18.3166 12.468 18.3311 12.946 17.7878C15.374 15.0281 19 12.8174 19 8.8686C19 5.07518 15.866 2 12 2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const Location10Icon = /* @__PURE__ */ createTerraIcon({
  icon: Location10IconData,
  displayName: 'Location10Icon',
});

const LocationAdd01IconData = [
  ['path', { d: "M15.5 11L12 11M12 11L8.5 11M12 11L12 14.5M12 11L12 7.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationAdd01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationAdd01IconData,
  displayName: 'LocationAdd01Icon',
});

const LocationAdd02IconData = [
  ['path', { d: "M15.5 10.3887H12M12 10.3887H8.5M12 10.3887L12 13.8887M12 10.3887L12 6.88873", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2.38873C7.30558 2.38873 3.5 6.00659 3.5 10.4694C3.5 15.3299 8.21916 17.758 11.1092 21.1947C11.5669 21.739 12.4531 21.7534 12.9211 21.2179C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00659 16.6944 2.38873 12 2.38873Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationAdd02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationAdd02IconData,
  displayName: 'LocationAdd02Icon',
});

const LocationCheck01IconData = [
  ['path', { d: "M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.5 12L10.5 14L15.5 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationCheck01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationCheck01IconData,
  displayName: 'LocationCheck01Icon',
});

const LocationCheck02IconData = [
  ['path', { d: "M12 2.38873C7.30558 2.38873 3.5 6.00659 3.5 10.4694C3.5 15.3299 8.21916 17.758 11.1092 21.1947C11.5669 21.739 12.4531 21.7534 12.9211 21.2179C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00659 16.6944 2.38873 12 2.38873Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.5 11.3887L10.5 13.3887L15.5 7.38873", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationCheck02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationCheck02IconData,
  displayName: 'LocationCheck02Icon',
});

const LocationFavourite01IconData = [
  ['path', { d: "M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.7431 8.28961C13.1465 7.45704 12 8.68433 12 8.68433C12 8.68433 10.8535 7.45704 9.25685 8.2896C7.32296 9.298 7.18408 13.2469 12 15C16.816 13.2469 16.677 9.298 14.7431 8.28961Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationFavourite01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationFavourite01IconData,
  displayName: 'LocationFavourite01Icon',
});

const LocationFavourite02IconData = [
  ['path', { d: "M12 2.38873C7.30558 2.38873 3.5 6.00659 3.5 10.4694C3.5 15.3299 8.21916 17.758 11.1092 21.1947C11.5669 21.739 12.4531 21.7534 12.9211 21.2179C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00659 16.6944 2.38873 12 2.38873Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.7431 7.17834C13.1465 6.34577 12 7.57306 12 7.57306C12 7.57306 10.8535 6.34577 9.25685 7.17833C7.32296 8.18673 7.18408 12.1357 12 13.8887C16.816 12.1357 16.677 8.18673 14.7431 7.17834Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationFavourite02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationFavourite02IconData,
  displayName: 'LocationFavourite02Icon',
});

const LocationOffline01IconData = [
  ['path', { d: "M9.07588 9.07588C8.71186 9.62797 8.5 10.2892 8.5 11C8.5 12.933 10.067 14.5 12 14.5C12.7108 14.5 13.372 14.2881 13.9241 13.9241M15.3835 11.899C15.4595 11.6121 15.5 11.3108 15.5 11C15.5 9.067 13.933 7.5 12 7.5C11.6892 7.5 11.3879 7.54051 11.101 7.61654", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M7 3.51555C8.4301 2.55827 10.1499 2 12 2C16.9706 2 21 6.02944 21 11C21 12.8656 20.3608 14.5181 19.423 15.9385M5.15559 5.15559C3.81158 6.72806 3 8.76925 3 11C3 18 12 22 12 22C12 22 15.2663 20.5483 17.8635 17.8635", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LocationOffline01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationOffline01IconData,
  displayName: 'LocationOffline01Icon',
});

const LocationOffline02IconData = [
  ['path', { d: "M7 3.51555C8.4301 2.55827 10.1499 2 12 2C16.9706 2 21 6.02944 21 11C21 12.8656 20.3608 14.5181 19.423 15.9385M5.15559 5.15559C3.81158 6.72806 3 8.76925 3 11C3 18 12 22 12 22C12 22 15.2663 20.5483 17.8635 17.8635", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationOffline02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationOffline02IconData,
  displayName: 'LocationOffline02Icon',
});

const LocationOffline03IconData = [
  ['path', { d: "M16.9124 16.9124C15.5849 18.2231 14.1142 19.4641 12.9213 20.8289C12.4533 21.3644 11.5669 21.3502 11.1092 20.806C8.21916 17.3692 3.5 14.9412 3.5 10.0807C3.5 8.25332 4.13806 6.5676 5.21393 5.21393M7.5 3.22404C8.80503 2.44833 10.3474 2 12 2C16.6944 2 20.5 5.61786 20.5 10.0807C20.5 11.8459 19.8643 13.3159 18.9143 14.6383", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.4376 11.1616C15.4785 10.9474 15.5 10.7262 15.5 10.5C15.5 8.567 13.933 7 12 7C11.7738 7 11.5526 7.02146 11.3384 7.06244M8.89097 8.89097C8.64114 9.3727 8.5 9.91987 8.5 10.5C8.5 12.433 10.067 14 12 14C12.5801 14 13.1273 13.8589 13.609 13.609", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LocationOffline03Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationOffline03IconData,
  displayName: 'LocationOffline03Icon',
});

const LocationOffline04IconData = [
  ['path', { d: "M16.9124 16.9124C15.5849 18.2231 14.1142 19.4641 12.9213 20.8289C12.4533 21.3644 11.5669 21.3502 11.1092 20.806C8.21916 17.3692 3.5 14.9412 3.5 10.0807C3.5 8.25332 4.13806 6.5676 5.21393 5.21393M7.5 3.22404C8.80503 2.44833 10.3474 2 12 2C16.6944 2 20.5 5.61786 20.5 10.0807C20.5 11.8459 19.8643 13.3159 18.9143 14.6383", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationOffline04Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationOffline04IconData,
  displayName: 'LocationOffline04Icon',
});

const LocationRemove01IconData = [
  ['path', { d: "M15.5 11H8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationRemove01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationRemove01IconData,
  displayName: 'LocationRemove01Icon',
});

const LocationRemove02IconData = [
  ['path', { d: "M15.5 10.3887H8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2.38873C7.30558 2.38873 3.5 6.00659 3.5 10.4694C3.5 15.3299 8.21916 17.758 11.1092 21.1947C11.5669 21.739 12.4531 21.7534 12.9211 21.2179C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00659 16.6944 2.38873 12 2.38873Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationRemove02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationRemove02IconData,
  displayName: 'LocationRemove02Icon',
});

const LocationShare01IconData = [
  ['path', { d: "M21.1677 7C22.2774 9.54466 22.2774 12.4569 21.1677 15.0015M2.83226 15.0015C1.72258 12.4569 1.72258 9.54466 2.83226 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 11.2C19 15.9809 13.8979 19.0126 12.4054 19.7971C12.1485 19.9322 11.8515 19.9322 11.5946 19.7971C10.1021 19.0126 5 15.9809 5 11.2C5 7.22355 8.13401 4 12 4C15.866 4 19 7.22355 19 11.2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M14.5 11C14.5 12.3807 13.3807 13.5 12 13.5C10.6193 13.5 9.5 12.3807 9.5 11C9.5 9.61929 10.6193 8.5 12 8.5C13.3807 8.5 14.5 9.61929 14.5 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
] as const;

export const LocationShare01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationShare01IconData,
  displayName: 'LocationShare01Icon',
});

const LocationShare02IconData = [
  ['path', { d: "M21.1677 6.90637C22.2774 9.45055 22.2774 12.3622 21.1677 14.9064M2.83226 14.9064C1.72258 12.3622 1.72258 9.45055 2.83226 6.90637", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.5 10.9064C14.5 12.2871 13.3807 13.4064 12 13.4064C10.6193 13.4064 9.5 12.2871 9.5 10.9064C9.5 9.52566 10.6193 8.40637 12 8.40637C13.3807 8.40637 14.5 9.52566 14.5 10.9064Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 3.90637C8.13401 3.90637 5 6.98155 5 10.775C5 14.8022 8.6928 16.8648 11.0836 19.672C11.5528 20.2229 12.468 20.2374 12.946 19.6941C15.374 16.9345 19 14.7238 19 10.775C19 6.98155 15.866 3.90637 12 3.90637Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const LocationShare02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationShare02IconData,
  displayName: 'LocationShare02Icon',
});

const LocationStar01IconData = [
  ['path', { d: "M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.6213 7.22724C11.779 6.92425 12.221 6.92425 12.3787 7.22724L13.3085 9.01387C13.3702 9.13246 13.4861 9.215 13.6203 9.23593L15.6414 9.55113C15.9839 9.60456 16.1204 10.0156 15.8755 10.2561L14.4286 11.6768C14.3328 11.7709 14.2886 11.9041 14.3097 12.0354L14.6286 14.0181C14.6826 14.3539 14.3251 14.6081 14.0158 14.4538L12.1929 13.5444C12.0717 13.484 11.9283 13.484 11.8071 13.5444L9.98419 14.4538C9.6749 14.6081 9.31738 14.3539 9.37139 14.0181L9.69029 12.0354C9.71141 11.9041 9.66722 11.7709 9.57138 11.6768L8.12453 10.2561C7.87959 10.0156 8.01609 9.60456 8.35863 9.55113L10.3797 9.23593C10.5139 9.215 10.6298 9.13246 10.6915 9.01387L11.6213 7.22724Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationStar01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationStar01IconData,
  displayName: 'LocationStar01Icon',
});

const LocationStar02IconData = [
  ['path', { d: "M12 2.38867C7.30558 2.38867 3.5 6.00653 3.5 10.4694C3.5 15.3299 8.21916 17.7579 11.1092 21.1946C11.5669 21.7389 12.4531 21.7533 12.9211 21.2178C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00653 16.6944 2.38867 12 2.38867Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.6213 7.11591C11.779 6.81293 12.221 6.81293 12.3787 7.11591L13.3085 8.90254C13.3702 9.02113 13.4861 9.10367 13.6203 9.1246L15.6414 9.4398C15.9839 9.49323 16.1204 9.90428 15.8755 10.1448L14.4286 11.5654C14.3328 11.6595 14.2886 11.7928 14.3097 11.9241L14.6286 13.9068C14.6826 14.2426 14.3251 14.4968 14.0158 14.3425L12.1929 13.4331C12.0717 13.3726 11.9283 13.3726 11.8071 13.4331L9.98419 14.3425C9.6749 14.4968 9.31738 14.2426 9.37139 13.9068L9.69029 11.9241C9.71141 11.7928 9.66722 11.6595 9.57138 11.5654L8.12453 10.1448C7.87959 9.90428 8.01609 9.49323 8.35863 9.4398L10.3797 9.1246C10.5139 9.10367 10.6298 9.02113 10.6915 8.90254L11.6213 7.11591Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LocationStar02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationStar02IconData,
  displayName: 'LocationStar02Icon',
});

const LocationUpdate01IconData = [
  ['path', { d: "M12.3966 16.8023C13.4956 16.2182 16.5 14.3598 16.5 11.5C16.5 9.01472 14.4853 7 12 7C9.51472 7 7.5 9.01472 7.5 11.5C7.5 14.3598 10.5044 16.2182 11.6034 16.8023C11.8533 16.9351 12.1467 16.9351 12.3966 16.8023Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.125 11.5H12M12.25 11.5C12.25 11.6381 12.1381 11.75 12 11.75C11.8619 11.75 11.75 11.6381 11.75 11.5C11.75 11.3619 11.8619 11.25 12 11.25C12.1381 11.25 12.25 11.3619 12.25 11.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 11.5L22 12C22 6.47715 17.5228 2 12 2C7.89936 2 4.3752 4.46819 2.83209 8M4 12.5L2 12C2 17.5228 6.47715 22 12 22C16.1006 22 19.6248 19.5318 21.1679 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LocationUpdate01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationUpdate01IconData,
  displayName: 'LocationUpdate01Icon',
});

const LocationUpdate02IconData = [
  ['path', { d: "M20 11L22 12C22 6.47715 17.5228 2 12 2C7.89936 2 4.3752 4.46819 2.83209 8M4 13L2 12C2 17.5228 6.47715 22 12 22C16.1006 22 19.6248 19.5318 21.1679 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.125 11H12M12.25 11C12.25 11.1381 12.1381 11.25 12 11.25C11.8619 11.25 11.75 11.1381 11.75 11C11.75 10.8619 11.8619 10.75 12 10.75C12.1381 10.75 12.25 10.8619 12.25 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 6.50012C9.51472 6.50012 7.5 8.48994 7.5 10.9445C7.5 12.348 8.0625 13.4393 9.1875 14.4141C9.91041 15.0405 11.1734 16.3208 11.8279 17.243C11.912 17.3615 12.0921 17.3642 12.1783 17.2473C12.8507 16.3363 14.0895 15.0406 14.8125 14.4141C15.9375 13.4393 16.5 12.348 16.5 10.9445C16.5 8.48994 14.4853 6.50012 12 6.50012Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LocationUpdate02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationUpdate02IconData,
  displayName: 'LocationUpdate02Icon',
});

const LocationUser01IconData = [
  ['path', { d: "M18 15.8V14C18 10.6863 15.3137 8 12 8C8.68629 8 6 10.6863 6 14V15.8C6 15.9105 6.08954 16 6.2 16H8.34384C8.43562 16 8.51561 16.0625 8.53787 16.1515L9.96213 21.8485C9.98439 21.9375 10.0644 22 10.1562 22H13.8438C13.9356 22 14.0156 21.9375 14.0379 21.8485L15.4621 16.1515C15.4844 16.0625 15.5644 16 15.6562 16H17.8C17.9105 16 18 15.9105 18 15.8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['circle', { cx: 12, cy: 5, r: 3, stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
] as const;

export const LocationUser01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationUser01IconData,
  displayName: 'LocationUser01Icon',
});

const LocationUser02IconData = [
  ['path', { d: "M7 13.9993H9L10.5 18.9993H13.5L15 13.9993H17V11.9993C17 9.23784 14.7614 6.99927 12 6.99927C9.23858 6.99927 7 9.23784 7 11.9993V13.9993Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 18.9962C19 20.6556 15.866 22.0008 12 22.0008C8.13401 22.0008 5 20.6556 5 18.9962", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['circle', { cx: 12, cy: 4.49927, r: 2.5, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LocationUser02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationUser02IconData,
  displayName: 'LocationUser02Icon',
});

const LocationUser03IconData = [
  ['path', { d: "M5 16.5C4.36284 17.0288 4 17.6682 4 18.3158C4 20.3505 7.58172 22 12 22C16.4183 22 20 20.3505 20 18.3158C20 17.6682 19.6372 17.0288 19 16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 14H9L10.5 19H13.5L15 14H17V12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12V14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['circle', { cx: 12, cy: 4.5, r: 2.5, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LocationUser03Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationUser03IconData,
  displayName: 'LocationUser03Icon',
});

const LocationUser04IconData = [
  ['path', { d: "M7 14H9L10.5 19H13.5L15 14H17V12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12V14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['circle', { cx: 12, cy: 4.5, r: 2.5, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18.5 17.5L19.875 20.5939C20.169 21.2551 19.6849 22 18.9612 22H4.97681C4.2694 22 3.78565 21.2856 4.04828 20.6287L5.49918 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LocationUser04Icon = /* @__PURE__ */ createTerraIcon({
  icon: LocationUser04IconData,
  displayName: 'LocationUser04Icon',
});

const LockComputerIconData = [
  ['path', { d: "M16.5 5.5H15V11H22V5.5H20.5M16.5 5.5V4C16.5 2.89543 17.3954 2 18.5 2C19.6046 2 20.5 2.89543 20.5 4V5.5M16.5 5.5H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11 2L4 2C2.89543 2 2 2.89543 2 4V15.9997C2 17.1043 2.89543 17.9997 4 17.9997H20C21.1046 17.9997 22 17.1043 22 15.9997V14.4997", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 15H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 18L12.0033 21.9953M12.0033 21.9953L16 22M12.0033 21.9953L8 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const LockComputerIcon = /* @__PURE__ */ createTerraIcon({
  icon: LockComputerIconData,
  displayName: 'LockComputerIcon',
});

const LockKeyIconData = [
  ['path', { d: "M15 9V6.5C15 4.01472 12.9853 2 10.5 2C8.01472 2 6 4.01472 6 6.5V9M18.5 11C18.5 9.89543 17.6046 9 16.5 9H4.50019C3.39554 9 2.50008 9.89554 2.50018 11.0002L2.50102 20.0002C2.50112 21.1047 3.39652 22 4.50102 22H8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M21.5 15.847L19.6243 14L17.3735 16.2164M17.3735 16.2164L15.1227 18.4328M17.3735 16.2164L18.4989 17.3246M15.1227 18.4328C15.9514 19.2488 15.9514 20.5719 15.1227 21.388C14.2939 22.204 12.9503 22.204 12.1215 21.388C11.2928 20.5719 11.2928 19.2488 12.1215 18.4328C12.9503 17.6167 14.2939 17.6167 15.1227 18.4328Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LockKeyIcon = /* @__PURE__ */ createTerraIcon({
  icon: LockKeyIconData,
  displayName: 'LockKeyIcon',
});

const LockPasswordIconData = [
  ['path', { d: "M17.9999 8.99902H6.00012C4.89548 8.99902 4.00002 9.89457 4.00012 10.9992L4.00095 19.9992C4.00106 21.1037 4.89646 21.999 6.00095 21.999H17.9999C19.1045 21.999 19.9999 21.1036 19.9999 19.999V10.999C19.9999 9.89445 19.1045 8.99902 17.9999 8.99902Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16.5001 8.99902V6.49902C16.5001 4.01374 14.4854 1.99902 12.0001 1.99902C9.51484 1.99902 7.50012 4.01374 7.50012 6.49902V8.99902", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12.1251 15.499H12.0001M12.2501 15.499C12.2501 15.6371 12.1382 15.749 12.0001 15.749C11.8621 15.749 11.7501 15.6371 11.7501 15.499C11.7501 15.361 11.8621 15.249 12.0001 15.249C12.1382 15.249 12.2501 15.361 12.2501 15.499Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M8.12512 15.499H8.00012M8.25012 15.499C8.25012 15.6371 8.13819 15.749 8.00012 15.749C7.86205 15.749 7.75012 15.6371 7.75012 15.499C7.75012 15.361 7.86205 15.249 8.00012 15.249C8.13819 15.249 8.25012 15.361 8.25012 15.499Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M16.1251 15.499H16.0001M16.2501 15.499C16.2501 15.6371 16.1382 15.749 16.0001 15.749C15.8621 15.749 15.7501 15.6371 15.7501 15.499C15.7501 15.361 15.8621 15.249 16.0001 15.249C16.1382 15.249 16.2501 15.361 16.2501 15.499Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LockPasswordIcon = /* @__PURE__ */ createTerraIcon({
  icon: LockPasswordIconData,
  displayName: 'LockPasswordIcon',
});

const LockSync01IconData = [
  ['path', { d: "M21.2154 16.0002C19.6684 19.532 16.1355 22.0002 12.0247 22.0002C6.48823 22.0002 2 17.5231 2 12.0002C2 6.47738 6.48823 2.00023 12.0247 2.00023C17.2229 2.00023 21.497 5.94691 22 11.0002L19.5 10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 11H8.5V16.5H15.5V11H14M10 11V9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5V11M10 11H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LockSync01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LockSync01IconData,
  displayName: 'LockSync01Icon',
});

const LockSync02IconData = [
  ['path', { d: "M21.2154 16.0002C19.6684 19.532 16.1355 22.0002 12.0247 22.0002C6.48823 22.0002 2 17.5231 2 12.0002C2 6.47738 6.48823 2.00023 12.0247 2.00023C17.2229 2.00023 21.497 5.94691 22 11.0002L19.5 10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.9286 11.3079V9.39C13.9286 8.34618 13.0651 7.5 12 7.5C10.9349 7.5 10.0714 8.34618 10.0714 9.39V11.3079M12 16.5C10.3431 16.5 9 15.1837 9 13.56C9 11.9363 10.3431 10.62 12 10.62C13.6569 10.62 15 11.9363 15 13.56C15 15.1837 13.6569 16.5 12 16.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LockSync02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LockSync02IconData,
  displayName: 'LockSync02Icon',
});

const LockIconData = [
  ['path', { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 13V16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LockIcon = /* @__PURE__ */ createTerraIcon({
  icon: LockIconData,
  displayName: 'LockIcon',
});

const LockedIconData = [
  ['path', { d: "M8 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V8M16 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V8M16 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V16M8 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9.71429 11H8L8 17H16V11H14.2857M9.71429 11V9.22222C9.71429 7.99492 10.7376 7 12 7C13.2624 7 14.2857 7.99492 14.2857 9.22222V11M9.71429 11H14.2857", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const LockedIcon = /* @__PURE__ */ createTerraIcon({
  icon: LockedIconData,
  displayName: 'LockedIcon',
});

const Locker01IconData = [
  ['path', { d: "M5.5 10H8.5M5.5 7H8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.5 10H18.5M15.5 7H18.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 3H4C2.89543 3 2 3.89543 2 5V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V5C22 3.89543 21.1046 3 20 3Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M20 19V21M4 19V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M12 3L12 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M8.375 14H8.25M8.5 14C8.5 14.1381 8.38807 14.25 8.25 14.25C8.11193 14.25 8 14.1381 8 14C8 13.8619 8.11193 13.75 8.25 13.75C8.38807 13.75 8.5 13.8619 8.5 14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M18.375 14H18.25M18.5 14C18.5 14.1381 18.3881 14.25 18.25 14.25C18.1119 14.25 18 14.1381 18 14C18 13.8619 18.1119 13.75 18.25 13.75C18.3881 13.75 18.5 13.8619 18.5 14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
] as const;

export const Locker01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Locker01IconData,
  displayName: 'Locker01Icon',
});

const LockerIconData = [
  ['path', { d: "M5.5 20H18.5C20.1569 20 21.5 18.6569 21.5 17V5C21.5 3.34315 20.1569 2 18.5 2H5.5C3.84315 2 2.5 3.34315 2.5 5V17C2.5 18.6569 3.84315 20 5.5 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6 20.5L6 22M18 20.5V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M12 8V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
  ['path', { d: "M9 13V14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M15 13V14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M2.5 8H21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "5" }],
] as const;

export const LockerIcon = /* @__PURE__ */ createTerraIcon({
  icon: LockerIconData,
  displayName: 'LockerIcon',
});

const Login01IconData = [
  ['path', { d: "M8 7.86859V7.34663C8 5.90823 9.02094 4.67225 10.4335 4.40061L17.4335 3.05446C19.2836 2.69866 21 4.1164 21 6.00048V17.9995C21 19.8836 19.2836 21.3013 17.4335 20.9455L10.4335 19.5994C9.02094 19.3278 8 18.0918 8 16.6534V16.1314", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 14.9995L16 11.9995L13 8.99953M15.5 11.9995H3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Login01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Login01IconData,
  displayName: 'Login01Icon',
});

const Login02IconData = [
  ['path', { d: "M14.8604 1.99986C14.3852 1.99986 14 2.38506 14 2.86024V21.1395C14 21.6147 14.3852 21.9999 14.8604 21.9999C14.9529 21.9999 15.0447 21.985 15.1325 21.9557L20.3162 20.2278C20.7246 20.0917 21 19.7095 21 19.2791V4.72062C21 4.29019 20.7246 3.90805 20.3162 3.77193L15.1325 2.04401C15.0447 2.01477 14.9529 1.99986 14.8604 1.99986Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 3.99986H9C8.44772 3.99986 8 4.44757 8 4.99986V5.99986M14 19.9999H9C8.44772 19.9999 8 19.5521 8 18.9999V17.9999", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8.5 14.4999L11 11.9999L8.5 9.49986M10 11.9999H3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Login02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Login02IconData,
  displayName: 'Login02Icon',
});

const Login03IconData = [
  ['path', { d: "M6 6V4C6 2.89543 6.89543 2 8 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H8C6.89543 22 6 21.1046 6 20V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10.5 16.5L16 12L10.5 7.5V10.5H4V13.5H10.5V16.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Login03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Login03IconData,
  displayName: 'Login03Icon',
});

const LoginCircle01IconData = [
  ['path', { d: "M3.00006 7.63576C4.6208 4.29965 8.04185 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5229 22 12 22C8.04185 22 4.6208 19.7004 3.00006 16.3642", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11 16L15 12L11 8M14 12H2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LoginCircle01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LoginCircle01IconData,
  displayName: 'LoginCircle01Icon',
});

const LoginCircle02IconData = [
  ['path', { d: "M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 16L9 12L13 8M10 12H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LoginCircle02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LoginCircle02IconData,
  displayName: 'LoginCircle02Icon',
});

const LoginMethodIconData = [
  ['path', { d: "M17.5 8.5C17.5 7.67157 16.8284 7 16 7H8C7.17157 7 6.5 7.67157 6.5 8.5V14C6.5 14.8284 7.17157 15.5 8 15.5H16C16.8284 15.5 17.5 14.8284 17.5 14V8.5Z", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M9 7V5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5V7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M13.5 19L10.5 22M10.5 19L13.5 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M21 19L18 22M18 19L21 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M6 19L3 22M3 19L6 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const LoginMethodIcon = /* @__PURE__ */ createTerraIcon({
  icon: LoginMethodIconData,
  displayName: 'LoginMethodIcon',
});

const LoginSquare01IconData = [
  ['path', { d: "M9 18V20C9 20.8284 9.67157 21.5 10.5 21.5H19.5C20.3284 21.5 21 20.8284 21 20V4C21 3.17157 20.3284 2.5 19.5 2.5H10.5C9.67157 2.5 9 3.17157 9 4V6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.5 15.5L16 12L12.5 8.5M15 12H3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LoginSquare01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LoginSquare01IconData,
  displayName: 'LoginSquare01Icon',
});

const LoginSquare02IconData = [
  ['path', { d: "M19.9999 7V4.5C19.9999 3.39543 19.1045 2.5 17.9999 2.5H5.99994C4.89537 2.5 3.99994 3.39543 3.99994 4.5V19.5C3.99994 20.6046 4.89537 21.5 5.99994 21.5H17.9999C19.1045 21.5 19.9999 20.6046 19.9999 19.5V17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 16L9 12L13 8M10 12H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LoginSquare02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LoginSquare02IconData,
  displayName: 'LoginSquare02Icon',
});

const Logout01IconData = [
  ['path', { d: "M15.5 7.86859V7.34663C15.5 5.90823 14.4791 4.67225 13.0665 4.40061L6.06655 3.05446C4.21637 2.69866 2.5 4.1164 2.5 6.00048V17.9995C2.5 19.8836 4.21636 21.3013 6.06654 20.9455L13.0665 19.5994C14.4791 19.3278 15.5 18.0918 15.5 16.6534V16.1314", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18.5 14.9995L21.5 11.9995L18.5 8.99953M21 11.9995H8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Logout01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Logout01IconData,
  displayName: 'Logout01Icon',
});

const Logout02IconData = [
  ['path', { d: "M10 2.86038V21.1396C10 21.6148 9.61479 22 9.13962 22C9.04714 22 8.95527 21.9851 8.86754 21.9558L3.68377 20.2279C3.27543 20.0918 3 19.7097 3 19.2792V4.72076C3 4.29033 3.27543 3.90819 3.68377 3.77208L8.86754 2.04415C8.95527 2.01491 9.04714 2 9.13962 2C9.61479 2 10 2.38521 10 2.86038Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 4H15C15.5523 4 16 4.44772 16 5V7M10 20H15C15.5523 20 16 19.5523 16 19V17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18.5 14.5L21 12L18.5 9.5M20 12H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Logout02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Logout02IconData,
  displayName: 'Logout02Icon',
});

const Logout03IconData = [
  ['path', { d: "M18 6V4C18 2.89543 17.1046 2 16 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H16C17.1046 22 18 21.1046 18 20V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.5 16.5L20 12L14.5 7.5V10.5H9V13.5H14.5V16.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Logout03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Logout03IconData,
  displayName: 'Logout03Icon',
});

const Logout04IconData = [
  ['path', { d: "M14.9999 6.5V4.5C14.9999 3.39543 14.1045 2.5 12.9999 2.5H4.99994C3.89537 2.5 2.99994 3.39543 2.99994 4.5V19.5C2.99994 20.6046 3.89537 21.5 4.99994 21.5H12.9999C14.1045 21.5 14.9999 20.6046 14.9999 19.5V17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 4.5H19C20.1046 4.5 21 5.39543 21 6.5V17.5C21 18.6046 20.1046 19.5 19 19.5H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.5 14.5L17 12L14.5 9.5M16 12H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const Logout04Icon = /* @__PURE__ */ createTerraIcon({
  icon: Logout04IconData,
  displayName: 'Logout04Icon',
});

const Logout05IconData = [
  ['path', { d: "M7.00002 21H4.50002C3.67159 21 3.00002 20.3284 3.00002 19.5L3.00002 4.49997C3.00002 3.67154 3.67159 2.99997 4.50002 2.99997L7.00002 2.99997", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16.5 7.49997L21 12L16.5 16.5M20 12L8.00002 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Logout05Icon = /* @__PURE__ */ createTerraIcon({
  icon: Logout05IconData,
  displayName: 'Logout05Icon',
});

const LogoutCircle01IconData = [
  ['path', { d: "M18.5 4.40041C16.752 2.9039 14.4815 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C14.4815 22 16.752 21.0961 18.5 19.5996", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 16L22 12L18 8M21 12H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LogoutCircle01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LogoutCircle01IconData,
  displayName: 'LogoutCircle01Icon',
});

const LogoutCircle02IconData = [
  ['path', { d: "M11.9474 21C7.00589 21 3 16.9706 3 12C3 7.02944 7.00589 3 11.9474 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17 16L21 12L17 8M20 12H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LogoutCircle02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LogoutCircle02IconData,
  displayName: 'LogoutCircle02Icon',
});

const LogoutSquare01IconData = [
  ['path', { d: "M14.5 18V20C14.5 20.8284 13.8284 21.5 13 21.5H4C3.17157 21.5 2.5 20.8284 2.5 20V4C2.5 3.17157 3.17157 2.5 4 2.5H13C13.8284 2.5 14.5 3.17157 14.5 4V6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 15.5L21.5 12L18 8.5M20.5 12H8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LogoutSquare01Icon = /* @__PURE__ */ createTerraIcon({
  icon: LogoutSquare01IconData,
  displayName: 'LogoutSquare01Icon',
});

const LogoutSquare02IconData = [
  ['path', { d: "M19.9999 7V4.5C19.9999 3.39543 19.1045 2.5 17.9999 2.5H5.99994C4.89537 2.5 3.99994 3.39543 3.99994 4.5V19.5C3.99994 20.6046 4.89537 21.5 5.99994 21.5H17.9999C19.1045 21.5 19.9999 20.6046 19.9999 19.5V17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16 16L20 12L16 8M19 12H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LogoutSquare02Icon = /* @__PURE__ */ createTerraIcon({
  icon: LogoutSquare02IconData,
  displayName: 'LogoutSquare02Icon',
});

const LollipopIconData = [
  ['circle', { cx: 12, cy: 8, r: 6, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 14V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6 7.99776C7 6.5439 9 5.66871 10.2857 6.11842C11.7609 6.63438 12.0271 8.35853 13.5 8.88051C15 9.4121 16 7.99776 18 7.99776", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LollipopIcon = /* @__PURE__ */ createTerraIcon({
  icon: LollipopIconData,
  displayName: 'LollipopIcon',
});

const LongSleeveShirtIconData = [
  ['path', { d: "M18 18H20.1172C20.6215 18 21.0469 17.6245 21.1095 17.124L22 10L20.5 4.5L15 2H9L3.5 4.5L2 10L2.8905 17.124C2.95306 17.6245 3.37846 18 3.88278 18H6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 2L9.77208 4.31623C9.90819 4.72457 10.2903 5 10.7208 5H13.2792C13.7097 5 14.0918 4.72457 14.2279 4.31623L15 2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M5.55078 8L6.20269 9.71695C6.39877 10.2334 6.48576 10.7848 6.45817 11.3365L6.02635 19.973C6.00986 20.3028 6.15522 20.6229 6.44704 20.7774C7.54034 21.356 9.72538 22 12.0508 22C14.3731 22 16.4808 21.3577 17.5543 20.7797C17.845 20.6231 17.9901 20.3028 17.9737 19.973L17.5455 11.4098C17.5155 10.8109 17.6206 10.213 17.853 9.66018L18.5508 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LongSleeveShirtIcon = /* @__PURE__ */ createTerraIcon({
  icon: LongSleeveShirtIconData,
  displayName: 'LongSleeveShirtIcon',
});

const LongitudeIconData = [
  ['path', { d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17 12C17 6.47715 14.7614 2 12 2C9.23858 2 7 6.47715 7 12C7 17.5228 9.23858 22 12 22C14.7614 22 17 17.5228 17 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 2V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LongitudeIcon = /* @__PURE__ */ createTerraIcon({
  icon: LongitudeIconData,
  displayName: 'LongitudeIcon',
});

const LookBottomIconData = [
  ['path', { d: "M9.5 17C10.2235 17.6334 11.0809 18 12 18C12.9191 18 13.7765 17.6334 14.5 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.625 11.887V12.4165M8.375 11.887V12.4165M8.75 12.25C8.75 11.8358 8.58211 11.5 8.375 11.5C8.16789 11.5 8 11.8358 8 12.25C8 12.6642 8.16789 13 8.375 13C8.58211 13 8.75 12.6642 8.75 12.25ZM16 12.25C16 11.8358 15.8321 11.5 15.625 11.5C15.4179 11.5 15.25 11.8358 15.25 12.25C15.25 12.6642 15.4179 13 15.625 13C15.8321 13 16 12.6642 16 12.25Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LookBottomIcon = /* @__PURE__ */ createTerraIcon({
  icon: LookBottomIconData,
  displayName: 'LookBottomIcon',
});

const LookLeftIconData = [
  ['path', { d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 14C8.08779 14.6072 6.63545 15 4.99963 15C3.87389 15 3.3355 14.8139 2.5 14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M7.625 8.387V8.91649M7.25 8.75C7.25 8.33579 7.41789 8 7.625 8C7.83211 8 8 8.33579 8 8.75C8 9.16421 7.83211 9.5 7.625 9.5C7.41789 9.5 7.25 9.16421 7.25 8.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LookLeftIcon = /* @__PURE__ */ createTerraIcon({
  icon: LookLeftIconData,
  displayName: 'LookLeftIcon',
});

const LookRightIconData = [
  ['circle', { cx: 12, cy: 12, r: 10, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 14C15.9122 14.6072 17.3645 15 19.0004 15C20.1261 15 20.6645 14.8139 21.5 14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16.375 8.387V8.91649M16.75 8.75C16.75 8.33579 16.5821 8 16.375 8C16.1679 8 16 8.33579 16 8.75C16 9.16421 16.1679 9.5 16.375 9.5C16.5821 9.5 16.75 9.16421 16.75 8.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LookRightIcon = /* @__PURE__ */ createTerraIcon({
  icon: LookRightIconData,
  displayName: 'LookRightIcon',
});

const LookTopIconData = [
  ['path', { d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9.5 12C10.2235 12.6334 11.0809 13 12 13C12.9191 13 13.7765 12.6334 14.5 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15.625 6.887V7.41649M8.375 6.887V7.41649M8.75 7.25C8.75 6.83579 8.58211 6.5 8.375 6.5C8.16789 6.5 8 6.83579 8 7.25C8 7.66421 8.16789 8 8.375 8C8.58211 8 8.75 7.66421 8.75 7.25ZM16 7.25C16 6.83579 15.8321 6.5 15.625 6.5C15.4179 6.5 15.25 6.83579 15.25 7.25C15.25 7.66421 15.4179 8 15.625 8C15.8321 8 16 7.66421 16 7.25Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LookTopIcon = /* @__PURE__ */ createTerraIcon({
  icon: LookTopIconData,
  displayName: 'LookTopIcon',
});

const LoomIconData = [
  ['path', { d: "M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M12 9V4M12 15V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 12L20 12M9 12L4 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M14.5996 10.5L18.9297 8M9.40341 13.5L5.07328 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M13.5 14.5976L16 18.9277M10.5 9.40145L8 5.07133", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M13.5 9.40239L16 5.07227M10.5 14.5985L8 18.9287", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M14.5996 13.5L18.9297 16M9.40341 10.5L5.07328 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
] as const;

export const LoomIcon = /* @__PURE__ */ createTerraIcon({
  icon: LoomIconData,
  displayName: 'LoomIcon',
});

const LottiefilesIconData = [
  ['path', { d: "M19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 7.5H16.8536C15.4009 7.5 14.0625 8.28757 13.357 9.55743L10.643 14.4426C9.93754 15.7124 8.59906 16.5 7.14639 16.5H6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const LottiefilesIcon = /* @__PURE__ */ createTerraIcon({
  icon: LottiefilesIconData,
  displayName: 'LottiefilesIcon',
});

const LoveKoreanFingerIconData = [
  ['path', { d: "M13.0974 11.569L6.20521 4.64771C5.6017 4.04165 5.60211 3.05998 6.20611 2.45443C6.81045 1.84854 7.79028 1.84852 8.39464 2.4544L16.2201 10.2995M16.2201 10.2995C17.923 12.0427 18.6685 13.2361 18.94 15.0205C19.061 15.8156 18.9985 16.6333 18.756 17.4C18.1298 19.3801 16.9949 20.6617 15.2009 21.52C14.5631 21.8251 13.8649 21.996 13.1582 21.9999C10.8618 22.0126 9.34219 20.9904 7.9938 19.7195L5.44001 17.1063C4.84141 16.4938 4.85533 15.5096 5.47101 14.9144C6.06771 14.3375 7.01283 14.3376 7.60938 14.9146L8.04025 15.3314M16.2201 10.2995C14.8524 8.53594 15.3551 6.48793 16.9072 5.35949C17.1833 5.1588 17.2491 4.75044 16.9719 4.55129C16.0962 3.92206 14.98 3.63006 14.0653 4.17127C12.7648 4.94074 12.5 6 12.5 6M10.8892 13.7884L8.37192 11.2327C7.77534 10.627 7.78725 9.64943 8.39841 9.05855C8.9906 8.486 9.92908 8.48779 10.5191 9.06258L13.09 11.5671M9.41521 16.741L8.04025 15.3314M8.04025 15.3314L6.90903 14.1717C6.31005 13.5577 6.32445 12.5721 6.94112 11.9758C7.5376 11.3992 8.48184 11.3976 9.08026 11.9722L9.49219 12.3678", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const LoveKoreanFingerIcon = /* @__PURE__ */ createTerraIcon({
  icon: LoveKoreanFingerIconData,
  displayName: 'LoveKoreanFingerIcon',
});

const LowSignalIconData = [
  ['path', { d: "M17 19V5H20V19H17Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10.5 19V8H13.5V19H10.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M5.5 12H4V19H5.5M5.5 12H7V19H5.5M5.5 12V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LowSignalIcon = /* @__PURE__ */ createTerraIcon({
  icon: LowSignalIconData,
  displayName: 'LowSignalIcon',
});

const LoyaltyCardIconData = [
  ['path', { d: "M20 3.5H4C2.89543 3.5 2 4.39543 2 5.5V18.5C2 19.6046 2.89543 20.5 4 20.5H20C21.1046 20.5 22 19.6046 22 18.5V5.5C22 4.39543 21.1046 3.5 20 3.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10.9002 11.7482C9.50317 11.0346 8.50003 12.0866 8.50003 12.0866C8.50003 12.0866 7.49684 11.0346 6.09974 11.7482C4.40759 12.6126 4.28607 15.9974 8.50003 17.5C12.714 15.9974 12.5924 12.6126 10.9002 11.7482Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M19 16.5H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LoyaltyCardIcon = /* @__PURE__ */ createTerraIcon({
  icon: LoyaltyCardIconData,
  displayName: 'LoyaltyCardIcon',
});

const Luggage01IconData = [
  ['path', { d: "M8.5 6L8.86073 3.8356C8.9411 3.35341 9.35829 3 9.84713 3H14.1529C14.6417 3 15.0589 3.35341 15.1393 3.8356L15.5 6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6 6V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 6V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M20 6H4C2.89543 6 2 6.89543 2 8V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V8C22 6.89543 21.1046 6 20 6Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const Luggage01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Luggage01IconData,
  displayName: 'Luggage01Icon',
});

const Luggage02IconData = [
  ['path', { d: "M9 2H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 2V8M14 2V8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8.5 20.5V22H9V20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M15.5 20.5V22H15V20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M16 8H8C6.89543 8 6 8.89543 6 10V18.5C6 19.6046 6.89543 20.5 8 20.5H16C17.1046 20.5 18 19.6046 18 18.5V10C18 8.89543 17.1046 8 16 8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M10 11V17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M14 11V17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
] as const;

export const Luggage02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Luggage02IconData,
  displayName: 'Luggage02Icon',
});

const LungsIconData = [
  ['path', { d: "M7 10C7 10 8.5 11 8.97397 11.9954M8.97397 11.9954C9.97037 13.665 9.97025 16.5 9.97025 16.5C9.97025 20 8.18605 21 5.98512 21C4.98884 21 2 20.5 2 16C2 9.5 5.48698 5 8.47583 5C10.8669 5 9.97174 10 8.97397 11.9954Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17 10C17 10 15.5 11 15.0251 11.9954M15.0251 11.9954C14.0286 13.665 14.0287 16.5 14.0287 16.5C14.0287 20 15.8132 21 18.0144 21C19.0108 21 22 20.5 22 16C22 9.5 18.5126 5 15.5234 5C13.132 5 14.0301 10 15.0251 11.9954Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14 7L12 5.66667M12 5.66667L10 7M12 5.66667V3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const LungsIcon = /* @__PURE__ */ createTerraIcon({
  icon: LungsIconData,
  displayName: 'LungsIcon',
});
